(function() {
  'use strict';

  // for testing/debugging in console
  // localStorage.removeItem('hasSeenNavigation');

  if (!window.pagePopupModulePromise) {
    window.pagePopupModulePromise = import('@theme/page-popup');
  }

  const shouldRestrictContent = () => {
    return ACCESS_CONTROL.mode === 'limited_public' && !ACCESS_CONTROL.isLoggedIn;
  };

  
  // Prevent multiple initializations
  if (window[`productScroll_${SECTION_ID}_initialized`]) {
    return;
  }
  window[`productScroll_${SECTION_ID}_initialized`] = true;

  
  
  // Constants
  const DEBOUNCE_DELAY = 100;
  const SWIPE_THRESHOLD = 30;
  const SWIPE_TIME_THRESHOLD = 800;
  const SWIPE_VELOCITY_THRESHOLD = 0.3;
  const HIGH_PRIORITY_LOAD = 3; // Number of slides to load at high priority
  
  // Get configuration
  const section = document.getElementById(SECTION_ID);
  const initialLoadCount = parseInt(section.dataset.initialLoad) || 5;
  const bufferCount = parseInt(section.dataset.bufferCount) || 3;
  
  // Load product data from JSON
  const productDataElement = document.getElementById(`${SECTION_ID}-product-data`);
  const productData = JSON.parse(productDataElement.textContent);
  const allProducts = productData.products;
  const totalProducts = allProducts.length;
  const totalProductSlides = allProducts.length;
  console.log('Total products from JSON:', productData.totalProducts, '| Actual products:', totalProductSlides, '| Total slides:', totalProducts);
  
  // Cache DOM elements
  const elements = {
    section: section,
    scrollContainer: null,
    slides: null,
    navOverlay: null,
    productInfoCard: null,
    imageSlider: null,
    captionArea: null,
    captionContent: null,
    productNavPrev: null,
    productNavNext: null,
    currentProductIndicator: null
  };

  const WHEEL_CONFIG = {
    THRESHOLD: 150,           // Amount of delta needed (higher = less sensitive)
    DAMPENING: 0.25,         // How much of the delta to use (lower = less sensitive)
    MIN_EVENTS: 4,           // Minimum wheel events before switching
    COOLDOWN_MS: 800,        // Cooldown between switches (ms)
    INACTIVITY_RESET: 300,   // Time before resetting accumulated values (ms)
    HORIZONTAL_RATIO: 2.0    // How much more horizontal than vertical (higher = stricter)
  };
  
  // State management
  const state = {
    currentProductIndex: 0,
    currentImageIndex: 0,
    imageSliderDots: [],
    isScrolling: false,
    touchStartX: 0,
    touchStartY: 0,
    touchStartTime: 0,
    isHorizontalSwipe: false,
    isVerticalSwipe: false,
    imagesLoaded: new Set(),
    videosLoaded: new Set(),
    scrollPositionBeforeLock: 0,
    loadedProducts: new Map(), // Track which products are loaded
    loadedSlides: new Set(), // Track which slide indices have been populated
    isLoadingProducts: false,
    lastLoadedIndex: -1,
    preloadQueue: [], // Queue for image preloading
    wheelDeltaX: 0,
    wheelTimeout: null,
    lastWheelTime: 0,
    isWheelNavigating: false,
    wheelEventCount: 0,
    pagePopupInitialized: false,
    pagePopupTrigger: null
  };
  
  // Utility functions
  const debounce = (func, wait) => {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  };
  
  const throttle = (func, limit) => {
    let inThrottle;
    return function(...args) {
      if (!inThrottle) {
        func.apply(this, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    };
  };

  // Video quality selection based on viewport size
  const getOptimalVideoUrl = (media) => {
    if (!media.videoQualities) {
      return media.url || media.mediaFile;
    }

    const viewportWidth = window.innerWidth;

    // Select quality based on viewport width
    if (viewportWidth <= 600) {
      return media.videoQualities.mobile || media.url || media.mediaFile;
    } else if (viewportWidth <= 1000) {
      return media.videoQualities.tablet || media.videoQualities.mobile || media.url || media.mediaFile;
    } else {
      return media.videoQualities.desktop || media.videoQualities.tablet || media.url || media.mediaFile;
    }
  };

  // Update video sources when viewport changes
  const updateVideoQuality = () => {
    if (!allProducts) return;

    const slides = document.querySelectorAll(`#${SECTION_ID} .product-slide`);

    slides.forEach((slide, slideIndex) => {
      if (!state.loadedProducts.has(slideIndex)) return;

      const product = allProducts[slideIndex];
      if (!product || !product.media) return;

      const videos = slide.querySelectorAll('.product-bg-video');

      videos.forEach((video, videoIndex) => {
        const media = product.media[videoIndex];
        if (!media || media.type !== 'video') return;

        const optimalUrl = getOptimalVideoUrl(media);
        const currentUrl = video.src || video.dataset.src;

        // Only update if URL changed
        if (optimalUrl !== currentUrl) {
          const wasPlaying = !video.paused;
          const currentTime = video.currentTime;

          if (video.src) {
            // Video is already loaded, update source
            video.src = optimalUrl;
            video.load();

            // Restore playback state
            if (wasPlaying) {
              video.currentTime = currentTime;
              video.play().catch(e => console.log('Video play failed after quality change:', e));
            }
          } else {
            // Video not yet loaded, update dataset
            video.dataset.src = optimalUrl;
          }
        }
      });
    });
  };


const fitOverlayTextToWidth = () => {
  // Get all overlay elements
  const overlays = document.querySelectorAll('.media-overlay');
  
  overlays.forEach(overlay => {
    // Skip if overlay is not visible
    if (overlay.style.display === 'none' || !overlay.offsetParent) return;
    
    // Get the text content directly (the innerHTML is the text)
    const textElement = overlay;
    
    // Reset styles for accurate measurement
    overlay.style.whiteSpace = 'nowrap';
    overlay.style.fontSize = ''; // Reset to default
    
    // Get the available width of the overlay (accounting for padding)
    const overlayStyle = window.getComputedStyle(overlay);
    const paddingLeft = parseFloat(overlayStyle.paddingLeft) || 0;
    const paddingRight = parseFloat(overlayStyle.paddingRight) || 0;
    const availableWidth = overlay.offsetWidth - paddingLeft - paddingRight;
    
    if (availableWidth <= 0) return; // Skip if no width available
    
    // Create a temporary span to measure text
    const measureSpan = document.createElement('span');
    measureSpan.style.cssText = `
      position: absolute;
      visibility: hidden;
      white-space: nowrap;
      font-family: ${overlayStyle.fontFamily};
      font-weight: ${overlayStyle.fontWeight};
      letter-spacing: ${overlayStyle.letterSpacing};
    `;
    measureSpan.innerHTML = overlay.innerHTML;
    document.body.appendChild(measureSpan);
    
    // Binary search for the optimal font size
    let minSize = 8;
    let maxSize = 300;
    let bestSize = 16;
    
    while (minSize <= maxSize) {
      const fontSize = Math.floor((minSize + maxSize) / 2);
      measureSpan.style.fontSize = fontSize + 'px';
      
      const textWidth = measureSpan.offsetWidth;
      
      if (textWidth <= availableWidth) {
        bestSize = fontSize;
        minSize = fontSize + 1;
      } else {
        maxSize = fontSize - 1;
      }
    }
    
    // Clean up measurement span
    document.body.removeChild(measureSpan);
    
    // Apply the best fitting font size (95% for safety margin)
    const finalSize = Math.floor(bestSize * 0.95);
    
    // Apply constraints
    const constrainedSize = Math.max(12, Math.min(finalSize, 200));
    overlay.style.fontSize = constrainedSize + 'px';
    
    // Allow text to wrap naturally now that size is set
    overlay.style.whiteSpace = 'normal';
    overlay.style.lineHeight = '1.2';
  });
};

const debouncedFitOverlayText = debounce(fitOverlayTextToWidth, 100);

  // Lock/unlock body scroll
  const lockBodyScroll = () => {
    state.scrollPositionBeforeLock = window.pageYOffset;
    document.body.classList.add('scroll-locked');
    document.body.style.top = `-${state.scrollPositionBeforeLock}px`;
  };
  
  const unlockBodyScroll = () => {
    document.body.classList.remove('scroll-locked');
    document.body.style.top = '';
    window.scrollTo(0, state.scrollPositionBeforeLock);
  };

  // Initialize page popup functionality
  const initializePagePopup = () => {
    if (state.pagePopupInitialized) return;
    
    // Import the module
   window.pagePopupModulePromise.then(module => {
    const { PagePopupTrigger, DialogCloseEvent } = module;
      
      // Create a reusable trigger instance
      const trigger = new PagePopupTrigger();
      state.pagePopupTrigger = trigger;
      // Store globally so nested popups can use the same instance with cache
      window.pagePopupTriggerInstance = trigger;
      state.pagePopupInitialized = true;
      
      // Setup click handler for product URL links (both desktop and mobile)
      // Exclude cart buttons AND variant buttons (both desktop and mobile variants) from getting the info popup handler
      const productUrlLinks = document.querySelectorAll(`#${SECTION_ID} [data-product-url]:not([data-cart-btn]):not([data-variant-btn]):not([data-cart-btn-mobile]):not([data-variant-btn-mobile])`);
      productUrlLinks.forEach(link => {
        if (link) {
          // We'll decide which handler to use dynamically based on if it's a bundle
          attachInfoPopupHandler(link);
        }
      });
      
      // Attach popup to any pending elements
      attachPendingPopups();
      
      // Listen for popup dialog close to prevent navigation issues
      // The dialog component manipulates body scroll which can interfere with clicks
      document.addEventListener('dialog:close', (event) => {
        // Small delay to ensure dialog cleanup is complete
        setTimeout(() => {
          // Remove any lingering event blockers
          document.body.style.pointerEvents = '';
          
          // If main scroll is still active, maintain scroll lock
          if (document.body.classList.contains('scroll-locked')) {
            document.body.style.position = 'fixed';
            document.body.style.top = `-${state.scrollPositionBeforeLock}px`;
          }
        }, 100);
      });
      
    }).catch(error => {
      console.error('Failed to initialize page popup:', error);
    });
  };

// handle pending popups
const attachPendingPopups = () => {
  if (!state.pagePopupInitialized || !state.pagePopupTrigger) return;
  
  // Find all elements marked for popup attachment
  const pendingElements = document.querySelectorAll('[data-pending-popup="true"]');
  
  pendingElements.forEach(element => {
    if (element.href) {
      attachPagePopupToLink(element);
      element.removeAttribute('data-pending-popup');
    }
  });
  
  // Also check all customize buttons in current slides
  elements.slides.forEach(slide => {
    const customizeBtn = slide.querySelector('.customize-button[data-needs-popup]');
    if (customizeBtn && customizeBtn.href && !customizeBtn.hasAttribute('data-popup-attached')) {
      attachPagePopupToLink(customizeBtn);
      customizeBtn.setAttribute('data-popup-attached', 'true');
    }
  });
};

// Handler that decides whether to use local or AJAX based on bundle status
const attachInfoPopupHandler = (linkElement) => {
  if (!linkElement) return linkElement;
  
  // Check if already attached
  if (linkElement.hasAttribute('data-popup-attached')) {
    return linkElement;
  }
  
  // Mark as attached
  linkElement.setAttribute('data-popup-attached', 'true');
  
  // Create click handler that checks bundle status
  const clickHandler = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    
    // Get current product data to check if it's a bundle
    const currentSlide = getCurrentSlideIndex();
    const productIndex = currentSlide;
    const productData = state.loadedProducts.get(productIndex);
    
    if (!productData) {
      console.log('No product data available');
      return;
    }
    
    // Fall d: If product has bundles but also a non-bundle variant, use local description (product-info)
    const useLocalDescription = !productData.isBundle ||
      (productData.hasVariants && productData.firstNonBundleVariantId && !productData.allVariantsAreBundles);

    if (!useLocalDescription && productData.isBundle) {
      // For pure bundles (Fall b), use the AJAX popup handler (which will use cache if available)
      // Wait for popup to be initialized
      if (!state.pagePopupInitialized || !state.pagePopupTrigger) {
        setTimeout(() => {
          if (state.pagePopupInitialized && state.pagePopupTrigger) {
            state.pagePopupTrigger.dataset.pageUrl = linkElement.href;
            state.pagePopupTrigger.handleClick(event);
          }
        }, 100);
        return;
      }

      // The handleClick will use cached content if available (from prefetch)
      // fetchPageContent in PagePopupTrigger checks cache first

      // Convert absolute URL to relative to match the prefetch
      const url = new URL(linkElement.href);
      const relativeUrl = url.pathname + url.search;


      // Use the relative URL to match what was prefetched
      state.pagePopupTrigger.dataset.pageUrl = relativeUrl;
      await state.pagePopupTrigger.handleClick(event);
    } else {
      // For non-bundle products (Fall a) and mixed products with non-bundle variant (Fall d), use local description
      await showLocalProductDescription(productData, linkElement);
    }
  };
  
  // Add listener directly without cloning
  linkElement.addEventListener('click', clickHandler);
  
  return linkElement;
};

// Show local product description in popup
const showLocalProductDescription = async (productData, linkElement) => {
  if (!productData.description) {
    console.log('No product description available');
    return;
  }
  
  // Wait for page popup to be initialized
  if (!state.pagePopupInitialized || !state.pagePopupTrigger) {
    await new Promise(resolve => {
      const checkInterval = setInterval(() => {
        if (state.pagePopupInitialized && state.pagePopupTrigger) {
          clearInterval(checkInterval);
          resolve();
        }
      }, 100);
    });
  }
  
  // Create HTML content with the product description
  const contentHTML = `
    <div class="product-info-popup-content">
      <div class="product-description-wrapper">
        ${productData.description}
      </div>
    </div>
  `;
  
  // Create a document fragment with the content - include the expected structure
  const parser = new DOMParser();
  const doc = parser.parseFromString(`
    <!DOCTYPE html>
    <html>
      <head><title>${productData.title}</title></head>
      <body>
        <main class="main-content">
          <div class="shopify-section">
            ${contentHTML}
          </div>
        </main>
      </body>
    </html>
  `, 'text/html');
  
  // Show the content in popup using the existing popup system
  if (state.pagePopupTrigger) {
    await state.pagePopupTrigger.showPageInPopup(
      doc, 
      productData.title || 'Product Info',
      false,
      linkElement.href
    );
  }
};

// Custom handler for info button to use local description data (deprecated - kept for compatibility)
const attachLocalInfoPopup = (linkElement) => {
  if (!linkElement) return linkElement;
  
  // Check if already attached
  if (linkElement.hasAttribute('data-popup-attached')) {
    return linkElement;
  }
  
  // Mark as attached
  linkElement.setAttribute('data-popup-attached', 'true');
  
  // Create click handler that uses local data
  const clickHandler = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    
    // Get current product data from the current slide
    const currentSlide = getCurrentSlideIndex();
    const productIndex = currentSlide;
    const productData = state.loadedProducts.get(productIndex);
    
    if (!productData || !productData.description) {
      console.log('No product description available');
      return;
    }
    
    // Wait for page popup to be initialized
    if (!state.pagePopupInitialized || !state.pagePopupTrigger) {
      await new Promise(resolve => {
        const checkInterval = setInterval(() => {
          if (state.pagePopupInitialized && state.pagePopupTrigger) {
            clearInterval(checkInterval);
            resolve();
          }
        }, 100);
      });
    }
    
    // Create HTML content with the product description
    const contentHTML = `
      <div class="product-info-popup-content">
        <h1 class="product__title">${productData.title}</h1>
        <div class="product-description-wrapper">
          ${productData.description}
        </div>
      </div>
    `;
    
    // Create a document fragment with the content - include the expected structure
    const parser = new DOMParser();
    const doc = parser.parseFromString(`
      <!DOCTYPE html>
      <html>
        <head><title>${productData.title}</title></head>
        <body>
          <main class="main-content">
            <div class="shopify-section">
              ${contentHTML}
            </div>
          </main>
        </body>
      </html>
    `, 'text/html');
    
    // Show the content in popup using the existing popup system
    if (state.pagePopupTrigger) {
      await state.pagePopupTrigger.showPageInPopup(
        doc, 
        productData.title || 'Product Info',
        false,
        linkElement.href
      );
    }
  };
  
  // Add listener directly without cloning
  linkElement.addEventListener('click', clickHandler);
  
  return linkElement;
};

// Popup to Link
 const attachPagePopupToLink = (linkElement) => {
  if (!linkElement) return linkElement;
  
  // Check if already attached
  if (linkElement.hasAttribute('data-popup-attached')) {
    return linkElement;
  }
  
  // Mark as attached
  linkElement.setAttribute('data-popup-attached', 'true');
  
  // Create click handler
  const clickHandler = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    
    // Wait for popup to be initialized
    if (!state.pagePopupInitialized || !state.pagePopupTrigger) {
      // Queue the click
      setTimeout(() => {
        if (state.pagePopupInitialized && state.pagePopupTrigger) {
          // Convert to relative URL
          const url = new URL(linkElement.href);
          const relativeUrl = url.pathname + url.search;
          state.pagePopupTrigger.dataset.pageUrl = relativeUrl;
          state.pagePopupTrigger.handleClick(event);
        }
      }, 100);
      return;
    }
    
    // Convert to relative URL to match prefetch cache
    const url = new URL(linkElement.href);
    const relativeUrl = url.pathname + url.search;
    
    // Use the relative URL to match what was prefetched
    state.pagePopupTrigger.dataset.pageUrl = relativeUrl;
    await state.pagePopupTrigger.handleClick(event);
  };
  
  // Add listener directly without cloning
  linkElement.addEventListener('click', clickHandler);
  
  return linkElement;
};

  
 // Helper function to create customize button
const createCustomizeButton = (product) => {
  const config = product.buttonConfig;
  if (!config || !config.showCustomizeButton) return null;

  // Also check that adjustButtonPage is not blank
  if (!config.adjustButtonPage || config.adjustButtonPage === '' || config.adjustButtonPage === '#') return null;

   let href;
  if (shouldRestrictContent()) {
    href = `${ACCESS_CONTROL.loginUrl}`;
  } else {
    href = config.adjustButtonPage;
  }
  
  const button = document.createElement('a');
  button.href = href; // Link to metafield page
  button.className = 'customize-button';
  button.textContent = config.customizeButtonText;
  
  // Add positioning classes
  button.classList.add(`v-${config.customizeButtonVPosition || 'center'}`);
  button.classList.add(`h-${config.customizeButtonHPosition || 'center'}`);
  
  // Handle color - always comes as hex from metaobject
  const colorValue = String(config.customizeButtonColor).toLowerCase();
  const fontColorValue = String(config.customizeButtonFontColor).toLowerCase();
 
  button.style.color = fontColorValue;
  button.style.backgroundColor = colorValue;
  
  // Add data attribute to identify this as needing popup
  if (!shouldRestrictContent()) {
    button.setAttribute('data-needs-popup', 'true');
  }
  
  return button;
};
  
  // Create product slide HTML - OPTIMIZED VERSION
  const createProductSlide = (product, index) => {
    const slide = document.createElement('article');
    slide.className = 'product-slide';
    slide.setAttribute('data-product-id', product.id);
    slide.setAttribute('data-slide-index', index);
    slide.setAttribute('role', 'listitem');
    slide.setAttribute('aria-label', product.title);
    
    // Create media container
    const mediaContainer = document.createElement('div');
    mediaContainer.className = 'product-images';
    mediaContainer.setAttribute('role', 'img');
    mediaContainer.setAttribute('aria-label', `${product.title} images`);
    
    // Add first media item with overlay
    if (product.media && product.media.length > 0) {
      const firstMedia = product.media[0];
      
      // Create media wrapper
      const mediaWrapper = document.createElement('div');
      mediaWrapper.className = 'media-wrapper';
      
      // Create inner container
      const mediaInner = document.createElement('div');
      mediaInner.className = 'media-inner';
      
      // Add media element
      if (firstMedia.type === 'image') {
        const img = document.createElement('img');
        img.className = 'product-bg-image';
        
        // OPTIMIZED: Load full resolution immediately for first few slides
        if (index < HIGH_PRIORITY_LOAD) {
          if (firstMedia.srcset) {
            img.srcset = firstMedia.srcset;
            img.sizes = firstMedia.sizes;
          }
          img.src = firstMedia.url; // fallback
          img.loading = 'eager';
          img.fetchpriority = 'high';
          img.classList.add('active');
        } else {
          // For other slides, still start with blur effect
          img.className += ' loading';
          img.src = firstMedia.thumbUrl;
          img.dataset.src = firstMedia.url;
          if (firstMedia.srcset) {
            img.dataset.srcset = firstMedia.srcset;
            img.dataset.sizes = firstMedia.sizes;
          }
          img.loading = 'lazy';

          // Preload the full image in background
          if (index < 10) {
            const preloadImg = new Image();
            if (firstMedia.srcset) {
              preloadImg.srcset = firstMedia.srcset;
              preloadImg.sizes = firstMedia.sizes;
            }
            preloadImg.src = firstMedia.url;
          }
        }

        img.alt = firstMedia.alt;
        img.dataset.imageIndex = '0';
        // Remove fixed dimensions for responsive behavior
        
        mediaInner.appendChild(img);
      } else if (firstMedia.type === 'video' || firstMedia.type === 'external_video') {
        const video = document.createElement('video');
        video.className = 'product-bg-video active';
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.setAttribute('data-video-index', '0');
        
        const optimalVideoUrl = getOptimalVideoUrl(firstMedia);

        if (index < HIGH_PRIORITY_LOAD) {
          video.src = optimalVideoUrl;
          video.load();
        } else {
          video.dataset.src = optimalVideoUrl;
        }
        
        mediaInner.appendChild(video);
      }
      
      // Add overlays to inner container
      if (firstMedia.overlayEnabledDesktop && firstMedia.overlayTextDesktop) {
        const overlayDesktop = createOverlay(firstMedia, 'desktop');
        mediaInner.appendChild(overlayDesktop);
      }
      
      if (firstMedia.overlayEnabledMobile && firstMedia.overlayTextMobile) {
        const overlayMobile = createOverlay(firstMedia, 'mobile');
        mediaInner.appendChild(overlayMobile);
      }
      
      mediaWrapper.appendChild(mediaInner);
      
      mediaContainer.appendChild(mediaWrapper);
    }
    
    // Add customize button if configured - AFTER media
    if (product.buttonConfig?.showCustomizeButton) {
      const customizeBtn = createCustomizeButton(product);
      if (customizeBtn) {
        mediaContainer.appendChild(customizeBtn);
      }
    }
    
    slide.appendChild(mediaContainer);

    // Mobile caption area (embedded in slide for unified scroll)
    const slideCaption = document.createElement('div');
    slideCaption.className = 'slide-caption-mobile';
    if (product.media && product.media.length > 0) {
      const firstMedia = product.media[0];
      const isMobile = window.innerWidth < 1024;
      const heading = isMobile
        ? (firstMedia.captionHeadingMobile || '')
        : (firstMedia.captionHeadingDesktop || '');
      const headingTag = isMobile
        ? (firstMedia.headingTagMobile || 'h2')
        : (firstMedia.headingTagDesktop || 'h2');
      const text = isMobile
        ? (firstMedia.captionTextMobileHtml || firstMedia.captionTextMobile || '')
        : (firstMedia.captionTextHtml || firstMedia.captionText || '');
      let html = '';
      if (heading) html += `<${headingTag} class="caption-heading">${heading}</${headingTag}>`;
      html += text || '';
      slideCaption.innerHTML = html;
    }
    slide.appendChild(slideCaption);

    // Add product data with all media info
    const productDataDiv = document.createElement('div');
    productDataDiv.className = 'product-data';
    productDataDiv.hidden = true;
    productDataDiv.setAttribute('data-button-config', JSON.stringify(product.buttonConfig || {}));
    productDataDiv.setAttribute('data-product-title', product.title);
    productDataDiv.setAttribute('data-product-price', product.price);
    productDataDiv.setAttribute('data-product-compare-at-price', product.compareAtPrice || '');
    productDataDiv.setAttribute('data-product-id', product.variantId);
    productDataDiv.setAttribute('data-product-available', product.available);
    productDataDiv.setAttribute('data-product-url', product.url);
    productDataDiv.setAttribute('data-product-has-variants', product.hasVariants);
    productDataDiv.setAttribute('data-product-is-bundle', product.isBundle || false);
    productDataDiv.setAttribute('data-all-variants-are-bundles', product.allVariantsAreBundles || false);
    productDataDiv.setAttribute('data-first-non-bundle-variant-id', product.firstNonBundleVariantId || '');
    productDataDiv.setAttribute('data-image-count', product.media.length);
    productDataDiv.setAttribute('data-product-description', product.description || '');
    productDataDiv.setAttribute('data-media-config', JSON.stringify(product.media));
    productDataDiv.setAttribute('data-unit-price', product.unitPrice || '');
    productDataDiv.setAttribute('data-unit-price-measurement', JSON.stringify(product.unitPriceMeasurement || {}));
    
    slide.appendChild(productDataDiv);
    
    return slide;
  };

  // Helper function to create overlay
  const createOverlay = (mediaItem, device) => {
    const overlay = document.createElement('div');
    const isDesktop = device === 'desktop';
    
    overlay.className = `media-overlay ${isDesktop ? 'desktop-only' : 'mobile-only'}`;
    
    // Position classes
    const vPos = isDesktop ? mediaItem.overlayPositionVDesktop : mediaItem.overlayPositionVMobile;
    const hPos = isDesktop ? mediaItem.overlayPositionHDesktop : mediaItem.overlayPositionHMobile;
    
    overlay.classList.add(`position-${vPos || 'center'}`);
    overlay.classList.add(`position-${hPos === 'center' ? 'h-center' : hPos || 'center'}`);
    
    // Styles
    const width = isDesktop ? mediaItem.overlayWidthDesktop : mediaItem.overlayWidthMobile;
    const color = isDesktop ? mediaItem.overlayColorDesktop : mediaItem.overlayColorMobile;
    const opacity = isDesktop ? mediaItem.overlayOpacityDesktop : mediaItem.overlayOpacityMobile;
    const text = isDesktop ? mediaItem.overlayTextDesktop : mediaItem.overlayTextMobile;
    
    overlay.style.width = `${width || 100}%`;
    overlay.style.color = color || '#FFFFFF';
    overlay.style.opacity = `${(opacity || 100) / 100}`;

    overlay.style.setProperty('--overlay-width', width || 100);
    
    overlay.innerHTML = text;
    
    return overlay;
  };
  
  // Load product into slide
  // Setup caption expand/collapse functionality for mobile
  let setupCaptionTimeout = null;
  const setupCaptionExpand = () => {
    // Clear any pending setup
    if (setupCaptionTimeout) {
      clearTimeout(setupCaptionTimeout);
    }
    
    // Check if caption area exists
    const captionArea = elements.captionArea;
    if (!captionArea) return;
    
    // Wait for layout to settle
    setupCaptionTimeout = setTimeout(() => {

      const existingBtns = elements.captionContent.querySelectorAll('.caption-expand-btn');
      existingBtns.forEach(btn => btn.remove());
      
      // Clean up legacy draggable/expanded classes
      if (elements.productInfoCard) {
        elements.productInfoCard.classList.remove('draggable');
        elements.productInfoCard.classList.remove('expanded');
      }
      
      // Clear timeout reference
      setupCaptionTimeout = null;
    }, 150); // Slightly longer delay to ensure all updates are done
  };
  
  // Collapse the expanded card
  const collapseCard = () => {
    elements.productInfoCard.classList.remove('expanded');
    elements.productInfoCard.style.height = ''; // Reset inline height
    if (elements.expandOverlay) {
      elements.expandOverlay.classList.remove('active');
      setTimeout(() => {
        elements.expandOverlay.style.display = 'none';
      }, 300);
    }
  };
  
  // Handle click outside to collapse
  const setupExpandOverlay = () => {
    if (elements.expandOverlay) {
      elements.expandOverlay.addEventListener('click', collapseCard);
    }
  };
  
  // Swipe/drag functionality removed - caption area is now natively scrollable

  // Create end slide with conditional button
  /*
  const createEndSlide = (index) => {
    const slide = document.createElement('article');
    slide.className = 'product-slide end-slide';
    slide.setAttribute('data-slide-index', index);
    slide.setAttribute('role', 'listitem');
    slide.setAttribute('aria-label', 'View catalog');

    // Get translated button texts from data attributes
    const viewAllProductsText = section.dataset.viewAllProductsText || 'VIEW ALL PRODUCTS';
    const viewCatalogText = section.dataset.viewCatalogText || 'VIEW CATALOG';

    // Determine button text and link based on current URL
    const currentPath = window.location.pathname;
    const currentSearch = window.location.search;
    //const isPartsView = currentSearch.includes('view=parts');
    const isCatalogProducts = currentPath.includes('/pages/products');

    let buttonText = viewAllProductsText;
    let buttonLink = '/pages/products';

   
    if (isCatalogProducts || isPartsView) {
      buttonText = viewCatalogText;
      buttonLink = '/pages/catalog';
    }


    slide.innerHTML = `
      <div class="end-slide__content">
        <a href="${buttonLink}" class="end-slide__button">
          ${buttonText}
        </a>
      </div>
    `;

    return slide;
  };
  */

  const loadProductIntoSlide = (productIndex, slideElement) => {
    // Check if this is the end slide (last index)
  /*
    if (productIndex === totalProductSlides) {
      const endSlide = createEndSlide(productIndex);
      slideElement.className = endSlide.className;
      slideElement.innerHTML = endSlide.innerHTML;
      Array.from(endSlide.attributes).forEach(attr => {
        slideElement.setAttribute(attr.name, attr.value);
      });
      state.loadedSlides.add(productIndex);
      return;
    }
      */

    if (productIndex >= allProducts.length) return;

    const product = allProducts[productIndex];
    const newSlide = createProductSlide(product, productIndex);

    // Copy attributes and content
    slideElement.className = newSlide.className;
    slideElement.innerHTML = newSlide.innerHTML;

    // Copy all attributes
    Array.from(newSlide.attributes).forEach(attr => {
      slideElement.setAttribute(attr.name, attr.value);
    });

    state.loadedProducts.set(productIndex, product);
    state.loadedSlides.add(productIndex);

    // If this is current slide, load all media
    if (productIndex === state.currentProductIndex) {
      loadAllMediaForSlide(slideElement, product);
    }

    // Variant buttons are now handled via event delegation - no individual setup needed
  };
  
  // Load all media for a slide - FIXED VERSION
  const loadAllMediaForSlide = (slideElement, product) => {
  console.log('=== loadAllMediaForSlide called for:', product.title);
  const mediaContainer = slideElement.querySelector('.product-images');
  if (!mediaContainer || !product.media) {
    console.log('No mediaContainer or media, returning');
    return;
  }

  // IMPORTANT: Save references to elements we want to keep
  const existingNavOverlay = mediaContainer.querySelector('.product-navigation-overlay');
  const existingCustomizeBtn = mediaContainer.querySelector('.customize-button');
  console.log('Found existing navigation?', !!existingNavOverlay);
  console.log('Found existing customize button?', !!existingCustomizeBtn);
  
  // Clear only media wrappers, not the entire container
  const mediaWrappers = mediaContainer.querySelectorAll('.media-wrapper');
  mediaWrappers.forEach(wrapper => wrapper.remove());
  
  // Add all media with overlays
  product.media.forEach((media, index) => {
    const mediaWrapper = document.createElement('div');
    mediaWrapper.className = 'media-wrapper';
    mediaWrapper.style.display = index === 0 ? 'block' : 'none';
    
    // Create inner container
    const mediaInner = document.createElement('div');
    mediaInner.className = 'media-inner';
    
    if (media.type === 'image') {
      const img = document.createElement('img');
      img.className = `product-bg-image ${index === 0 ? 'active' : ''}`;
      
      // OPTIMIZED: Load first image at full resolution immediately
      if (index === 0) {
        if (media.srcset) {
          img.srcset = media.srcset;
          img.sizes = media.sizes;
        }
        img.src = media.url; // fallback
        img.loading = 'eager';
        img.fetchpriority = 'high';
        state.imagesLoaded.add(img);
      } else {
        // For other images, prepare for quick loading
        img.classList.add('loading');
        img.src = media.thumbUrl;
        img.dataset.src = media.url;
        if (media.srcset) {
          img.dataset.srcset = media.srcset;
          img.dataset.sizes = media.sizes;
        }
        img.loading = 'lazy';

        // Preload next image
        if (index === 1) {
          const preloadImg = new Image();
          if (media.srcset) {
            preloadImg.srcset = media.srcset;
            preloadImg.sizes = media.sizes;
          }
          preloadImg.src = media.url;
        }
      }

      img.alt = media.alt;
      img.dataset.imageIndex = index.toString();
      // Remove fixed dimensions for responsive behavior
      
      mediaInner.appendChild(img);
    } else if (media.type === 'video' || media.type === 'external_video') {
      const video = document.createElement('video');
      video.className = `product-bg-video ${index === 0 ? 'active' : ''}`;
      video.muted = true;
      video.loop = true;
      video.playsInline = true;

      const optimalVideoUrl = getOptimalVideoUrl(media);
      video.dataset.src = optimalVideoUrl;
      video.setAttribute('data-video-index', index.toString());
      
      mediaInner.appendChild(video);
      
      if (index === 0) {
        loadMedia(video);
      }
    }
    
    // Add overlays to inner container
    if (media.overlayEnabledDesktop && media.overlayTextDesktop) {
      mediaInner.appendChild(createOverlay(media, 'desktop'));
    }
    
    if (media.overlayEnabledMobile && media.overlayTextMobile) {
      mediaInner.appendChild(createOverlay(media, 'mobile'));
    }
    
    mediaWrapper.appendChild(mediaInner);
    
    mediaContainer.appendChild(mediaWrapper);
  });

  requestAnimationFrame(() => {
    fitOverlayTextToWidth();
  });
  
  // Re-append navigation overlay if it exists (it should be after all media wrappers)
  if (existingNavOverlay) {
    console.log('Re-appending existing navigation overlay');
    mediaContainer.appendChild(existingNavOverlay);
  } else {
    console.log('WARNING: No existing navigation overlay found to re-append!');
  }
  
  // Handle customize button
  if (existingCustomizeBtn) {
    // Re-append existing customize button
    mediaContainer.appendChild(existingCustomizeBtn);
    // Re-attach popup handler (innerHTML in loadProductIntoSlide destroys event listeners)
    if (existingCustomizeBtn.hasAttribute('data-needs-popup')) {
      existingCustomizeBtn.removeAttribute('data-popup-attached');
      if (state.pagePopupInitialized && state.pagePopupTrigger) {
        attachPagePopupToLink(existingCustomizeBtn);
      } else {
        existingCustomizeBtn.setAttribute('data-pending-popup', 'true');
      }
    }
  } else if (product.buttonConfig?.showCustomizeButton) {
    // Create new customize button if needed
    const customizeBtn = createCustomizeButton(product);
    if (customizeBtn) {
      mediaContainer.appendChild(customizeBtn);
      
      // Attach popup if page popup is initialized
      if (state.pagePopupInitialized && state.pagePopupTrigger) {
        attachPagePopupToLink(customizeBtn);
      } else {
        // Mark for later attachment
        customizeBtn.setAttribute('data-pending-popup', 'true');
      }
    }
  }
};
  
  // Progressive media loading - OPTIMIZED VERSION
  const loadMedia = (media) => {
    if (media.tagName === 'IMG') {
      // Remove the check for already loaded images if src is thumbnail
      if (!media.dataset.src) return;
      
      // Check if we're still showing thumbnail (Shopify: width=300 or w=300, Cloudinary: w_300)
      const isShowingThumbnail = media.src.includes('width=300') || media.src.includes('w=300') || media.src.includes('w_300');
      
      if (state.imagesLoaded.has(media) && !isShowingThumbnail) return;
      
      // Skip loading animation for already loaded images
      if (media.complete && media.naturalHeight !== 0 && !isShowingThumbnail) {
        media.classList.remove('loading');
        state.imagesLoaded.add(media);
        return;
      }
      
      const tempImg = new Image();
      tempImg.onload = () => {
        if (media.dataset.srcset) {
          media.srcset = media.dataset.srcset;
          media.sizes = media.dataset.sizes;
        }
        media.src = media.dataset.src;
        media.classList.remove('loading');
        state.imagesLoaded.add(media);
      };
      tempImg.onerror = () => {
        media.classList.add('error');
        console.error('Failed to load image:', media.dataset.src);
      };
      if (media.dataset.srcset) {
        tempImg.srcset = media.dataset.srcset;
        tempImg.sizes = media.dataset.sizes;
      }
      tempImg.src = media.dataset.src;
    } else if (media.tagName === 'VIDEO') {
      if (!media.dataset.src || state.videosLoaded.has(media)) return;
      
      media.src = media.dataset.src;
      media.load();
      
      media.onloadeddata = () => {
        state.videosLoaded.add(media);
        if (media.classList.contains('active')) {
          media.play().catch(e => console.log('Video autoplay failed:', e));
        }
      };
    }
  };
  
  // Check if more products need to be loaded
  const checkAndLoadMoreProducts = () => {
    // Don't create more slides if we already have enough elements
    if (state.isLoadingProducts || elements.slides.length >= totalProducts) return;

    const currentIndex = state.currentProductIndex;
    const maxLoadedIndex = Math.max(...Array.from(state.loadedSlides));

    // Load more if we're within buffer distance of the end
    if (currentIndex >= maxLoadedIndex - bufferCount) {
      loadMoreProducts();
    }
  };
  
  // Load more products
  const loadMoreProducts = () => {
    if (state.isLoadingProducts) return;

    state.isLoadingProducts = true;

    // Use actual number of slide elements, not loaded products count
    const startIndex = elements.slides.length;
    const endIndex = Math.min(startIndex + initialLoadCount, totalProducts);

    // Don't create slides if we already have enough
    if (startIndex >= totalProducts) {
      state.isLoadingProducts = false;
      return;
    }
    
    // Add placeholder slides
    const fragment = document.createDocumentFragment();
    for (let i = startIndex; i < endIndex; i++) {
      const placeholder = document.createElement('article');
      placeholder.className = 'product-slide placeholder';
      placeholder.setAttribute('data-slide-index', i);
      placeholder.setAttribute('role', 'listitem');
      placeholder.setAttribute('aria-label', 'Loading product');
      fragment.appendChild(placeholder);
    }

    elements.scrollContainer.appendChild(fragment);
    
    // Update slides reference
    elements.slides = elements.scrollContainer.querySelectorAll('.product-slide');
    
    // Load products into placeholders
    setTimeout(() => {
      for (let i = startIndex; i < endIndex; i++) {
        const slideElement = elements.slides[i];
        if (slideElement) {
          loadProductIntoSlide(i, slideElement);
        }
      }
      state.isLoadingProducts = false;
    }, 100);
  };
  
  // Get viewport height - mobile-aware
  const getViewportHeight = () => {
    // For mobile with header offset, always use actual slide height
    if (window.innerWidth < 750 && elements.slides && elements.slides[0]) {
      // Use actual slide height to account for header offset
      return elements.slides[0].offsetHeight;
    }
    
    // Desktop uses full viewport
    return window.innerHeight || document.documentElement.clientHeight;
  };
  
  // Calculate current slide index
  const getCurrentSlideIndex = () => {
    const scrollTop = elements.scrollContainer.scrollTop;
    const totalSlides = elements.slides.length;

    // Mobile: variable-height slides, find by offset
    if (window.innerWidth < 750) {
      const viewMid = scrollTop + elements.scrollContainer.clientHeight / 2;
      for (let i = totalSlides - 1; i >= 0; i--) {
        if (elements.slides[i].offsetTop <= viewMid) {
          return i;
        }
      }
      return 0;
    }

    // Desktop: fixed-height slides
    const slideHeight = getViewportHeight();
    let currentSlide = Math.round(scrollTop / slideHeight);
    currentSlide = Math.max(0, Math.min(currentSlide, totalSlides - 1));
    return currentSlide;
  };
  
  // Mobile snap removed — product switching is handled by swipe gestures
  
  // Slide boundary detection (for mobile unified scroll)
  const getSlideScrollState = () => {
    const idx = getCurrentSlideIndex();
    const slide = elements.slides[idx];
    if (!slide) return { atTop: true, atBottom: true, overflows: false };

    const scrollTop = elements.scrollContainer.scrollTop;
    const containerH = elements.scrollContainer.clientHeight;
    const slideTop = slide.offsetTop;
    const slideBottom = slideTop + slide.offsetHeight;

    const atTop = scrollTop <= slideTop + 2;
    const atBottom = scrollTop + containerH >= slideBottom - 2;
    const overflows = slide.offsetHeight > containerH + 2;

    return { atTop, atBottom, overflows };
  };

  // Force refresh button states - debounced to avoid excessive updates
  let buttonStateRefreshTimeout;
  const forceRefreshButtonStates = debounce((slideIndex) => {
    if (typeof console !== 'undefined' && console.log) {
      console.log('Forcing button state refresh for slide:', slideIndex);
    }
    
    // Get the slide and force update button states
    const slide = elements.slides[slideIndex];
    if (slide && !slide.classList.contains('placeholder')) {
      const productData = slide.querySelector('.product-data');
      if (productData) {
        const data = {
          hasVariants: productData.getAttribute('data-product-has-variants') === 'true',
          buttonConfig: JSON.parse(productData.getAttribute('data-button-config') || '{}')
        };
        
        // Force update button visibility with EXCLUSIVE button logic
        const cartBtn = elements.productInfoCard?.querySelector('[data-cart-btn]');
        const section = document.getElementById(SECTION_ID);
        const variantBtn = section?.querySelector('.variant-btn-card');
        const parent = cartBtn?.parentElement;
        const adjustBtn = parent?.querySelector('.adjust-btn-card');
        
        if (cartBtn && data.buttonConfig) {
          // EXCLUSIVE BUTTON LOGIC: Check for adjust button first
          if (data.buttonConfig.showAdjustButton && data.buttonConfig.adjustButtonPage) {
            // Show ONLY adjust button, hide all others
            if (adjustBtn) {
              adjustBtn.style.setProperty('display', 'flex', 'important');
              adjustBtn.style.visibility = 'visible';
              adjustBtn.removeAttribute('aria-hidden');
              adjustBtn.removeAttribute('data-force-hidden');
            }
            
            // Hide cart button
            cartBtn.style.setProperty('display', 'none', 'important');
            cartBtn.style.visibility = 'hidden';
            cartBtn.setAttribute('aria-hidden', 'true');
            cartBtn.setAttribute('data-force-hidden', 'true');
            
            // Hide variant button
            if (variantBtn) {
              variantBtn.style.setProperty('display', 'none', 'important');
              variantBtn.style.visibility = 'hidden';
              variantBtn.disabled = true;
              variantBtn.setAttribute('aria-hidden', 'true');
              variantBtn.setAttribute('data-force-hidden', 'true');
            }
          } else if (data.buttonConfig.hideAddToCart) {
            // Hide ALL buttons when add to cart is disabled
            cartBtn.style.setProperty('display', 'none', 'important');
            cartBtn.style.visibility = 'hidden';
            cartBtn.setAttribute('aria-hidden', 'true');
            cartBtn.setAttribute('data-force-hidden', 'true');
            
            if (variantBtn) {
              variantBtn.style.setProperty('display', 'none', 'important');
              variantBtn.style.visibility = 'hidden';
              variantBtn.disabled = true;
              variantBtn.setAttribute('aria-hidden', 'true');
              variantBtn.setAttribute('data-force-hidden', 'true');
            }
            
            if (adjustBtn) {
              adjustBtn.style.setProperty('display', 'none', 'important');
              adjustBtn.style.visibility = 'hidden';
              adjustBtn.setAttribute('aria-hidden', 'true');
              adjustBtn.setAttribute('data-force-hidden', 'true');
            }
          } else if (data.hasVariants) {
            // Show ONLY variant button, hide all others
            cartBtn.style.setProperty('display', 'none', 'important');
            cartBtn.style.visibility = 'hidden';
            cartBtn.setAttribute('aria-hidden', 'true');
            cartBtn.setAttribute('data-force-hidden', 'true');
            
            if (variantBtn) {
              variantBtn.style.setProperty('display', 'flex', 'important');
              variantBtn.style.visibility = 'visible';
              variantBtn.disabled = false;
              variantBtn.removeAttribute('aria-hidden');
              variantBtn.removeAttribute('data-force-hidden');
            }
            
            if (adjustBtn) {
              adjustBtn.style.setProperty('display', 'none', 'important');
              adjustBtn.style.visibility = 'hidden';
              adjustBtn.setAttribute('aria-hidden', 'true');
              adjustBtn.setAttribute('data-force-hidden', 'true');
            }
          } else {
            // Show ONLY cart button, hide all others
            cartBtn.style.setProperty('display', 'flex', 'important');
            cartBtn.style.visibility = 'visible';
            cartBtn.removeAttribute('aria-hidden');
            cartBtn.removeAttribute('data-force-hidden');
            
            if (variantBtn) {
              variantBtn.style.setProperty('display', 'none', 'important');
              variantBtn.style.visibility = 'hidden';
              variantBtn.disabled = true;
              variantBtn.setAttribute('aria-hidden', 'true');
              variantBtn.setAttribute('data-force-hidden', 'true');
            }
            
            if (adjustBtn) {
              adjustBtn.style.setProperty('display', 'none', 'important');
              adjustBtn.style.visibility = 'hidden';
              adjustBtn.setAttribute('aria-hidden', 'true');
              adjustBtn.setAttribute('data-force-hidden', 'true');
            }
          }
        }
      }
    }
  }, 100);

  // Update scroll indicator
  const updateScrollIndicator = throttle(() => {
    const currentSlide = getCurrentSlideIndex();

    if (currentSlide !== state.currentProductIndex) {
      // Load the current slide first if it's a placeholder
      const slideElement = elements.slides[currentSlide];
      if (slideElement && slideElement.classList.contains('placeholder')) {
        console.log('Loading placeholder slide:', currentSlide);
        loadProductIntoSlide(currentSlide, slideElement);
        // Wait for DOM update before updating info card
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            console.log('Updating info card after placeholder load for slide:', currentSlide);
            const loadedSlide = elements.slides[currentSlide];
            console.log('Slide has product-data:', !!loadedSlide.querySelector('.product-data'));
            updateProductInfoCard(currentSlide);
            state.currentProductIndex = currentSlide;
          });
        });
      } else {
        updateProductInfoCard(currentSlide);
        state.currentProductIndex = currentSlide;
      }

      // Check if we need to load more products
      checkAndLoadMoreProducts();

      // Load media for current and adjacent slides
      preloadAdjacentSlides(currentSlide);
    }
    
    // ALWAYS force refresh button states after a short delay to catch any timing issues
    // This ensures button states are correct even if there were timing issues
    forceRefreshButtonStates(currentSlide);
    
    // Mobile: no auto-snap — product switching is handled by touch swipe gestures
  }, 50);
  
  // Preload adjacent slides - OPTIMIZED VERSION
  const preloadAdjacentSlides = (currentIndex) => {
    const indices = [
      currentIndex - 1,
      currentIndex,
      currentIndex + 1,
      currentIndex + 2 // Preload one extra ahead
    ].filter(i => i >= 0 && i < elements.slides.length);
    
    indices.forEach(index => {
      const slide = elements.slides[index];
      if (!slide || slide.classList.contains('placeholder')) return;
      
      const product = state.loadedProducts.get(index);
      if (product) {
        if (index === currentIndex) {
          // Load all media for current slide
          loadAllMediaForSlide(slide, product);
        } else {
          // Preload first image for adjacent slides
          const firstImg = slide.querySelector('.product-bg-image');
          if (firstImg && firstImg.dataset.src && !state.imagesLoaded.has(firstImg)) {
            // Use Image constructor to preload
            const preloadImg = new Image();
            if (firstImg.dataset.srcset) {
              preloadImg.srcset = firstImg.dataset.srcset;
              preloadImg.sizes = firstImg.dataset.sizes;
            }
            preloadImg.src = firstImg.dataset.src;
            state.preloadQueue.push(preloadImg);
          }
        }
      }
    });
  };
  
  // Update image slider dots
    const updateImageSlider = (productIndex) => {
      console.log('=== updateImageSlider DEBUG START ===');
      console.log('Product Index:', productIndex);

      const product = state.loadedProducts.get(productIndex);
      if (!product) {
        console.log('ERROR: No product found in state.loadedProducts');
        return;
      }
      console.log('Product found:', product.title);
      console.log('Product media array:', product.media);
      console.log('Initial product.media.length:', product.media.length);

      const currentSlide = elements.slides[productIndex];
      if (!currentSlide) {
        console.log('ERROR: No currentSlide found');
        return;
      }

      // Get media count - fallback to checking DOM if product.media is empty
      let mediaCount = product.media.length;
      console.log('Initial mediaCount from product.media:', mediaCount);

      // If media count is 0 or 1, check if there's media config in the DOM
      if (mediaCount <= 1) {
        console.log('mediaCount <= 1, checking DOM for media config...');
        const productData = currentSlide.querySelector('.product-data');
        console.log('productData element found:', !!productData);

        if (productData) {
          const mediaConfigStr = productData.getAttribute('data-media-config');
          console.log('data-media-config attribute:', mediaConfigStr ? 'Found' : 'Not found');
          console.log('data-media-config value (first 200 chars):', mediaConfigStr ? mediaConfigStr.substring(0, 200) : 'null');

          if (mediaConfigStr) {
            try {
              const mediaConfig = JSON.parse(mediaConfigStr);
              console.log('Parsed mediaConfig:', mediaConfig);
              console.log('Is array:', Array.isArray(mediaConfig));
              console.log('Array length:', mediaConfig ? mediaConfig.length : 'null');

              if (mediaConfig && Array.isArray(mediaConfig) && mediaConfig.length > 1) {
                mediaCount = mediaConfig.length;
                console.log('Updated mediaCount from DOM:', mediaCount);
              } else {
                console.log('mediaConfig invalid or length <= 1');
              }
            } catch (e) {
              console.log('ERROR: Could not parse media config:', e);
            }
          }
        }
      }

      console.log('Final mediaCount:', mediaCount);

      // Get the product-images container where we'll add the navigation
      const productImagesContainer = currentSlide.querySelector('.product-images');
      console.log('productImagesContainer found:', !!productImagesContainer);
      if (!productImagesContainer) {
        console.log('ERROR: No productImagesContainer found');
        return;
      }
      
      // Get or create slide-specific image slider
      let slideImageSlider = currentSlide.querySelector('.image-slider');
      if (!slideImageSlider) {
        slideImageSlider = document.createElement('div');
        slideImageSlider.className = 'image-slider';
        slideImageSlider.setAttribute('role', 'tablist');
        slideImageSlider.setAttribute('aria-label', 'Image navigation');
        productImagesContainer.appendChild(slideImageSlider);
      }
      
      // Get or create navigation overlay INSIDE product-images
      let navOverlay = productImagesContainer.querySelector('.product-navigation-overlay');
      console.log('navOverlay exists:', !!navOverlay);

      if (!navOverlay) {
        console.log('Creating new navOverlay...');
        navOverlay = document.createElement('div');
        navOverlay.className = 'product-navigation-overlay';
        navOverlay.setAttribute('data-product-navigation', '');
        
        // Create previous button
        const prevBtn = document.createElement('button');
        prevBtn.className = 'product-nav-btn product-nav-prev';
        prevBtn.setAttribute('data-product-nav-prev', '');
        prevBtn.setAttribute('type', 'button');
        prevBtn.setAttribute('aria-label', 'Previous image');
        prevBtn.innerHTML = `
          <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>
            <title>Previous</title>
            <g id="left_line" fill='none' fill-rule='evenodd'>
              <path d='M24 0v24H0V0h24ZM12.593 23.258l-.011.002-.071.035-.02.004-.014-.004-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01-.017.428.005.02.01.013.104.074.015.004.012-.004.104-.074.012-.016.004-.017-.017-.427c-.002-.01-.009-.017-.017-.018Zm.265-.113-.013.002-.185.093-.01.01-.003.011.018.43.005.012.008.007.201.093c.012.004.023 0 .029-.008l.004-.014-.034-.614c-.003-.012-.01-.02-.02-.022Zm-.715.002a.023.023 0 0 0-.027.006l-.006.014-.034.614c0 .012.007.02.017.024l.015-.002.201-.093.01-.008.004-.011.017-.43-.003-.012-.01-.01-.184-.092Z'/>
              <path fill='#000000' d='M8.293 12.707a1 1 0 0 1 0-1.414l5.657-5.657a1 1 0 1 1 1.414 1.414L10.414 12l4.95 4.95a1 1 0 0 1-1.414 1.414l-5.657-5.657Z'/>
            </g>
          </svg>
        `;
        
        // Create next button
        const nextBtn = document.createElement('button');
        nextBtn.className = 'product-nav-btn product-nav-next';
        nextBtn.setAttribute('data-product-nav-next', '');
        nextBtn.setAttribute('type', 'button');
        nextBtn.setAttribute('aria-label', 'Next image');
        nextBtn.innerHTML = `
          <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' style="transform: rotate(180deg);">
            <title>Next</title>
            <g id="right_line" fill='none' fill-rule='evenodd'>
              <path d='M24 0v24H0V0h24ZM12.593 23.258l-.011.002-.071.035-.02.004-.014-.004-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01-.017.428.005.02.01.013.104.074.015.004.012-.004.104-.074.012-.016.004-.017-.017-.427c-.002-.01-.009-.017-.017-.018Zm.265-.113-.013.002-.185.093-.01.01-.003.011.018.43.005.012.008.007.201.093c.012.004.023 0 .029-.008l.004-.014-.034-.614c-.003-.012-.01-.02-.02-.022Zm-.715.002a.023.023 0 0 0-.027.006l-.006.014-.034.614c0 .012.007.02.017.024l.015-.002.201-.093.01-.008.004-.011.017-.43-.003-.012-.01-.01-.184-.092Z'/>
              <path fill='#000000' d='M8.293 12.707a1 1 0 0 1 0-1.414l5.657-5.657a1 1 0 1 1 1.414 1.414L10.414 12l4.95 4.95a1 1 0 0 1-1.414 1.414l-5.657-5.657Z'/>
            </g>
          </svg>
        `;
        
        // Add click handlers
        prevBtn.onclick = (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (state.imageSliderDots.length > 1 && state.currentImageIndex > 0) {
            const newImageIndex = state.currentImageIndex - 1;
            switchToMedia(productIndex, newImageIndex);
          }
        };
        
        nextBtn.onclick = (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (state.imageSliderDots.length > 1 && state.currentImageIndex < state.imageSliderDots.length - 1) {
            const newImageIndex = state.currentImageIndex + 1;
            switchToMedia(productIndex, newImageIndex);
          }
        };
        
        navOverlay.appendChild(prevBtn);
        navOverlay.appendChild(nextBtn);

        // IMPORTANT: Append to product-images container, not the slide
        productImagesContainer.appendChild(navOverlay);
        console.log('navOverlay appended to productImagesContainer');
      } else {
        console.log('Using existing navOverlay');
      }

      console.log('navOverlay final element:', navOverlay);
      console.log('navOverlay current display:', window.getComputedStyle(navOverlay).display);

      // Store references to navigation buttons for this slide
      const slideNavPrev = navOverlay.querySelector('.product-nav-prev');
      const slideNavNext = navOverlay.querySelector('.product-nav-next');
      console.log('slideNavPrev found:', !!slideNavPrev);
      console.log('slideNavNext found:', !!slideNavNext);
      
      // Clear existing dots
      slideImageSlider.innerHTML = '';
      state.imageSliderDots = [];
      
      // Hide slider and navigation if only one media item
      if (mediaCount <= 1) {
        console.log('Hiding navigation: mediaCount <= 1');
        slideImageSlider.style.display = 'none';
        navOverlay.style.display = 'none';
        console.log('=== updateImageSlider DEBUG END (HIDDEN) ===');
        return;
      }

      console.log('Showing navigation: mediaCount =', mediaCount);
      slideImageSlider.style.display = 'flex';
      navOverlay.style.display = 'flex';
      console.log('navOverlay display set to:', navOverlay.style.display);
      
      
      
      // Create dots
      const fragment = document.createDocumentFragment();
      for (let i = 0; i < mediaCount; i++) {
        const dot = document.createElement('button');
        dot.className = `image-dot${i === 0 ? ' active' : ''}`;
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', `Image ${i + 1}`);
        dot.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        dot.setAttribute('data-image', i.toString());
        dot.addEventListener('click', () => switchToMedia(productIndex, i));
        fragment.appendChild(dot);
        state.imageSliderDots.push(dot);
      }
      slideImageSlider.appendChild(fragment);
      
     
      
      // Reset current image index if needed
      if (state.currentImageIndex >= mediaCount) {
        state.currentImageIndex = 0;
      }
      
      // Update navigation button states IMMEDIATELY
      if (slideNavPrev) {
        slideNavPrev.disabled = state.currentImageIndex === 0;
        console.log('slideNavPrev disabled:', slideNavPrev.disabled);
      }
      if (slideNavNext) {
        slideNavNext.disabled = state.currentImageIndex >= mediaCount - 1;
        console.log('slideNavNext disabled:', slideNavNext.disabled);
      }

      console.log('Created', state.imageSliderDots.length, 'dots');
      console.log('=== updateImageSlider DEBUG END (SUCCESS) ===');

    };
  
  // Switch to specific media - OPTIMIZED VERSION
  const switchToMedia = (productIndex, mediaIndex) => {
    if (productIndex >= elements.slides.length) return;
    
    const slide = elements.slides[productIndex];
    if (!slide) return;
    
    const mediaWrappers = slide.querySelectorAll('.media-wrapper');
    const allMedia = slide.querySelectorAll('.product-bg-image, .product-bg-video');
    
    if (mediaWrappers.length === 0) return;
    
    // Ensure index is valid
    mediaIndex = Math.max(0, Math.min(mediaIndex, mediaWrappers.length - 1));
    
    // Update media wrappers visibility
    mediaWrappers.forEach((wrapper, index) => {
      wrapper.style.display = index === mediaIndex ? 'block' : 'none';
    });

    // Add font resizing for newly visible overlays
      requestAnimationFrame(() => {
        fitOverlayTextToWidth();
      });
    
    // Update media active states
    allMedia.forEach((media, index) => {
      const isActive = index === mediaIndex;
      media.classList.toggle('active', isActive);
      
      if (isActive) {
        if (media.dataset.src) loadMedia(media);
        
        if (media.tagName === 'VIDEO') {
          media.play().catch(e => console.log('Video play failed:', e));
        }
        
        // Preload next image if exists
        const nextMedia = allMedia[index + 1];
        if (nextMedia && nextMedia.tagName === 'IMG' && nextMedia.dataset.src) {
          const preloadImg = new Image();
          if (nextMedia.dataset.srcset) {
            preloadImg.srcset = nextMedia.dataset.srcset;
            preloadImg.sizes = nextMedia.dataset.sizes;
          }
          preloadImg.src = nextMedia.dataset.src;
        }
      } else if (media.tagName === 'VIDEO') {
        media.pause();
      }
    });
    
    // Update caption based on current media
    const productData = slide.querySelector('.product-data');
    if (productData && elements.captionContent) {
      const mediaConfig = JSON.parse(productData.getAttribute('data-media-config') || '[]');
      const currentMedia = mediaConfig[mediaIndex];
      
      if (currentMedia) {
        // Determine which caption to show based on viewport
        const isMobile = window.innerWidth < 1024;
        const captionHeading = isMobile ?
          (currentMedia.captionHeadingMobile || '') :
          (currentMedia.captionHeadingDesktop || '');
        const headingTag = isMobile ?
          (currentMedia.headingTagMobile || 'h2') :
          (currentMedia.headingTagDesktop || 'h2');
        const captionText = isMobile ? 
          (currentMedia.captionTextMobileHtml || currentMedia.captionTextMobile || '') : 
          (currentMedia.captionTextHtml || currentMedia.captionText || '');
        
        let captionHtml = '';
        if (captionHeading) {
          captionHtml += `<${headingTag} class="caption-heading">${captionHeading}</${headingTag}>`;
        }
        captionHtml += captionText || '';
        
        elements.captionContent.innerHTML = captionHtml;

        // Also update the embedded slide caption on mobile
        if (window.innerWidth < 750) {
          const slideCaption = slide.querySelector('.slide-caption-mobile');
          if (slideCaption) {
            slideCaption.innerHTML = captionHtml;
          }
        }

        if (window.innerWidth < 750) {
          setupCaptionExpand();
        }
      }
    }

    // Update dots
   state.imageSliderDots.forEach((dot, index) => {
        const isActive = index === mediaIndex;
        dot.classList.toggle('active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      // Update navigation button states wenn Bild gewechselt wird
      const product = state.loadedProducts.get(productIndex);
      const mediaCount = product ? product.media.length : 1;

      if (elements.productNavPrev) {
        elements.productNavPrev.disabled = mediaCount <= 1 || mediaIndex === 0;
      }

      if (elements.productNavNext) {
        elements.productNavNext.disabled = mediaCount <= 1 || mediaIndex >= mediaCount - 1;
      }

      // Update navigation button states for this specific slide
       const productImagesContainer = slide.querySelector('.product-images');
          const navOverlay = productImagesContainer ? productImagesContainer.querySelector('.product-navigation-overlay') : null;
          if (navOverlay) {
            const slideNavPrev = navOverlay.querySelector('.product-nav-prev');
            const slideNavNext = navOverlay.querySelector('.product-nav-next');
            
            const product = state.loadedProducts.get(productIndex);
            const mediaCount = product ? product.media.length : 1;
            
            if (slideNavPrev) {
              slideNavPrev.disabled = mediaCount <= 1 || mediaIndex === 0;
            }
            
            if (slideNavNext) {
              slideNavNext.disabled = mediaCount <= 1 || mediaIndex >= mediaCount - 1;
            }
          }
          

      state.currentImageIndex = mediaIndex;

  };
  
  // Update product info card
  const updateProductInfoCard = (slideIndex) => {
    if (slideIndex >= elements.slides.length || slideIndex < 0) return;

    const slide = elements.slides[slideIndex];
    if (!slide || !elements.productInfoCard || slide.classList.contains('placeholder')) return;

    // Check if this is the end slide and hide info card
    if (slide.classList.contains('end-slide')) {
      elements.productInfoCard.style.display = 'none';
      return;
    }

    // Show info card if it was hidden
    elements.productInfoCard.style.display = '';

    const productData = slide.querySelector('.product-data');
    if (!productData) return;

    //  Reset image index beim Produktwechsel
  if (slideIndex !== state.currentProductIndex) {
    state.currentImageIndex = 0;
  }
    
    // Extract data
    const data = {
      title: productData.getAttribute('data-product-title'),
      price: productData.getAttribute('data-product-price'),
      compareAtPrice: productData.getAttribute('data-product-compare-at-price'),
      unitPrice: productData.getAttribute('data-unit-price'),
      unitPriceMeasurement: JSON.parse(productData.getAttribute('data-unit-price-measurement') || '{}'),
      productId: productData.getAttribute('data-product-id'),
      available: productData.getAttribute('data-product-available') === 'true',
      hasVariants: productData.getAttribute('data-product-has-variants') === 'true',
      isBundle: productData.getAttribute('data-product-is-bundle') === 'true',
      allVariantsAreBundles: productData.getAttribute('data-all-variants-are-bundles') === 'true',
      firstNonBundleVariantId: productData.getAttribute('data-first-non-bundle-variant-id') || null,
      url: productData.getAttribute('data-product-url'),
      description: productData.getAttribute('data-product-description'),
       buttonConfig: JSON.parse(productData.getAttribute('data-button-config') || '{}')
    };
    
    // Update elements - handle both mobile and desktop positions
    const titleElements = document.querySelectorAll(`#${SECTION_ID} [data-product-title]`);
    const priceElement = elements.productInfoCard.querySelector('[data-product-price]');
    const mobilePriceElement = elements.section.querySelector('[data-product-price-mobile]');
    const mobilePreorderContainer = elements.section.querySelector('[data-preorder-btn-container-mobile]');
    const cartBtn = elements.productInfoCard.querySelector('[data-cart-btn]');
    const infoBtns = document.querySelectorAll(`#${SECTION_ID} [data-product-info-btn]`);
    const productUrlLinks = document.querySelectorAll(`#${SECTION_ID} [data-product-url]`);

    // Update all product URL links (both mobile and desktop)
    if (productUrlLinks && productUrlLinks.length > 0 && data.url) {
        // Fall d: If product has bundles but also a non-bundle variant, use product-info with that variant
        let popupUrl;
        if (data.hasVariants && data.firstNonBundleVariantId && data.isBundle && !data.allVariantsAreBundles) {
          // Fall d: Use first non-bundle variant for specs
          popupUrl = `${data.url}?variant=${data.firstNonBundleVariantId}&view=product-info`;
        } else if (data.isBundle) {
          // Fall b: Bundle without variants or single bundle
          popupUrl = `${data.url}?view=bundle-info`;
        } else {
          // Fall a: Normal product
          popupUrl = `${data.url}?view=product-info`;
        }
        
        productUrlLinks.forEach(link => {
          if (link) link.href = popupUrl;
        });
      

      
     // PREFETCH using the popup trigger's own cache!
    if (state.pagePopupInitialized && state.pagePopupTrigger) {
      // This will cache it in the trigger's #pageCache
      // Store the URL we're prefetching so we know it's cached
      if (!state.prefetchedUrls) {
        state.prefetchedUrls = new Set();
      }
      state.prefetchedUrls.add(popupUrl);
      
      state.pagePopupTrigger.fetchPageContent(popupUrl).then(() => {
        // After product info is cached, prefetch the adjust page if configured
        if (data.buttonConfig && data.buttonConfig.adjustButtonPage && 
            (data.buttonConfig.showAdjustButton || data.buttonConfig.showCustomizeButton)) {
          const adjustPageUrl = data.buttonConfig.adjustButtonPage;
          if (adjustPageUrl && adjustPageUrl !== '#' && !shouldRestrictContent()) {
            state.prefetchedUrls.add(adjustPageUrl);
            // Small delay to avoid abort controller conflict
            setTimeout(() => {
              state.pagePopupTrigger.fetchPageContent(adjustPageUrl).catch(err => {
                console.log('Adjust page prefetch failed:', err);
                state.prefetchedUrls.delete(adjustPageUrl);
              });
            }, 50);
          }
        }
      }).catch(err => {
        console.log('Prefetch failed:', err);
        state.prefetchedUrls.delete(popupUrl);
      });
    }
    }
    
    // Update all title elements (both mobile and desktop)
    if (titleElements && titleElements.length > 0) {
      titleElements.forEach(titleEl => {
        if (titleEl) titleEl.textContent = data.title || 'Product';
      });
    }

    // Info Button hide - handle both mobile and desktop
    // Only hide buttons that contain SVG (the three dots), not the ones containing the title
    // Fall c: Hide specs button if ALL variants are bundles
    const shouldHideSpecs = data.buttonConfig.hideInfoButton || (data.hasVariants && data.allVariantsAreBundles);

    if (infoBtns && infoBtns.length > 0) {
      infoBtns.forEach(btn => {
        // Check if this button contains an SPECS-btn
        if (btn && btn.querySelector('.specs-btn')) {
          // This is the icon button, hide its parent container
          if (btn.parentElement) {
            btn.parentElement.style.display = shouldHideSpecs ? 'none' : 'flex';
          }
        } else {
          // This is the title link - disable/enable it based on hideInfoButton setting
          if (shouldHideSpecs) {
            // Remove link functionality when specs are hidden
            btn.style.pointerEvents = 'none';
            btn.style.cursor = 'default';
            btn.removeAttribute('href');
          } else {
            // Restore link functionality when specs are visible
            btn.style.pointerEvents = '';
            btn.style.cursor = '';
            if (data.url) {
              // Use same URL logic as productUrlLinks
              let specsUrl;
              if (data.hasVariants && data.firstNonBundleVariantId && data.isBundle && !data.allVariantsAreBundles) {
                specsUrl = `${data.url}?variant=${data.firstNonBundleVariantId}&view=product-info`;
              } else if (data.isBundle) {
                specsUrl = `${data.url}?view=bundle-info`;
              } else {
                specsUrl = `${data.url}?view=product-info`;
              }
              btn.href = specsUrl;
            }
          }
        }
      });
    }

    let priceHTML = '';

   if (priceElement) {
     priceElement.innerHTML = '';
  
  if (shouldRestrictContent()) {
    priceElement.innerHTML = `<span class="price-login-required">${ACCESS_CONTROL.loginMessage}</span>`;
    priceElement.style.display = 'block';
  } else if (data.buttonConfig.hidePrice) {
    if (data.buttonConfig.priceReplacementText) {
      priceElement.innerHTML = `<span>${data.buttonConfig.priceReplacementText}</span>`;
      priceElement.style.display = 'block';
    } else {
      priceElement.style.display = 'none';
      // Clear the content even when hiding
      priceElement.innerHTML = '';
    }
  } else {
    priceElement.style.display = 'block';
    
    if (data.buttonConfig.priceReplacementText) {
      priceElement.innerHTML = `<span>${data.buttonConfig.priceReplacementText}</span>`;
    } else {
      let priceHTML = '';
      
      // Check for the string 'null' or empty price
      const hasValidPrice = data.price && data.price !== 'null' && data.price !== '';
      
      if (!hasValidPrice) {
        // Handle missing or null price explicitly
        priceHTML = `<span>€0.00</span>`;
      } else if (data.compareAtPrice && data.compareAtPrice !== data.price && data.compareAtPrice !== 'null') {
        priceHTML = `<span style="text-decoration: line-through; opacity: 0.6;">${data.compareAtPrice}</span>`;
        priceHTML += `<span style="color: #e53e3e;">${data.price}</span>`;
      } else {
        priceHTML = `<span>${data.price}</span>`;
      }
      
      if (data.unitPrice && data.unitPrice !== 'null' && data.unitPriceMeasurement.referenceValue) {
        priceHTML += `<span class="unit-price">${data.unitPrice} / ${data.unitPriceMeasurement.referenceUnit || ''}</span>`;
      }
      
      priceElement.innerHTML = priceHTML;
    }
  }

    // Sync mobile price element
    if (mobilePriceElement && priceElement) {
      mobilePriceElement.innerHTML = priceElement.innerHTML;
      mobilePriceElement.style.display = priceElement.style.display;
    }

   // Update navigation indicator
        if (elements.currentProductIndicator) {
          elements.currentProductIndicator.textContent = slideIndex + 1;
        }

        // NEU: Update button states für BILD-Navigation (nicht mehr Produkt-Navigation)
        const product = state.loadedProducts.get(slideIndex);
        const mediaCount = product ? product.media.length : 1;

        if (elements.productNavPrev) {
          // Deaktiviert wenn erstes Bild oder nur ein Bild vorhanden
          elements.productNavPrev.disabled = mediaCount <= 1 || state.currentImageIndex === 0;
        }

        if (elements.productNavNext) {
          // Deaktiviert wenn letztes Bild oder nur ein Bild vorhanden
          elements.productNavNext.disabled = mediaCount <= 1 || state.currentImageIndex >= mediaCount - 1;
        }

  }
    
    // Only set caption from first media item if we're not already showing a different image
    if (elements.captionContent && productData && state.currentImageIndex === 0) {
      const mediaConfig = JSON.parse(productData.getAttribute('data-media-config') || '[]');
      if (mediaConfig.length > 0) {
        const firstMedia = mediaConfig[0];
        const isMobile = window.innerWidth < 1024;
        const captionHeading = isMobile ?
          (firstMedia.captionHeadingMobile || '') :
          (firstMedia.captionHeadingDesktop || '');
        const headingTag = isMobile ?
          (firstMedia.headingTagMobile || 'h2') :
          (firstMedia.headingTagDesktop || 'h2');
        const captionText = isMobile ? 
          (firstMedia.captionTextMobileHtml || firstMedia.captionTextMobile || '') : 
          (firstMedia.captionTextHtml || firstMedia.captionText || '');
        
        let captionHtml = '';
        if (captionHeading) {
          captionHtml += `<${headingTag} class="caption-heading">${captionHeading}</${headingTag}>`;
        }
        captionHtml += captionText || '';
        
        elements.captionContent.innerHTML = captionHtml;

        // Also update the embedded slide caption on mobile
        if (window.innerWidth < 750 && slide) {
          const slideCaption = slide.querySelector('.slide-caption-mobile');
          if (slideCaption) {
            slideCaption.innerHTML = captionHtml;
          }
        }

        if (window.innerWidth < 750) {
          setupCaptionExpand();
        }
      }
    }

    if (cartBtn) {
        const parent = cartBtn.parentElement;
    
        // First, handle adjust button if needed
        if (data.buttonConfig.showAdjustButton && data.buttonConfig.adjustButtonPage) {
          // Get variant button reference from section to ensure proper hiding
          const section = document.getElementById(SECTION_ID);
          const variantBtn = elements.productInfoCard ? elements.productInfoCard.querySelector('[data-variant-btn]') : null;

          // Replace with adjust button
          let adjustBtn = parent.querySelector('.adjust-btn-card');
          if (!adjustBtn) {
            adjustBtn = document.createElement('a');
            adjustBtn.className = 'adjust-btn-card';
            adjustBtn.innerHTML = `
            <svg xmlns='http://www.w3.org/2000/svg' width='32px' height='32px' viewBox='0 0 24 24'><title>settings_2_line</title><g id="settings_2_line" fill='none' fill-rule='evenodd'><path d='M24 0v24H0V0zM12.593 23.258l-.011.002-.071.035-.02.004-.014-.004-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01-.017.428.005.02.01.013.104.074.015.004.012-.004.104-.074.012-.016.004-.017-.017-.427c-.002-.01-.009-.017-.017-.018m.265-.113-.013.002-.185.093-.01.01-.003.011.018.43.005.012.008.007.201.093c.012.004.023 0 .029-.008l.004-.014-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014-.034.614c0 .012.007.02.017.024l.015-.002.201-.093.01-.008.004-.011.017-.43-.003-.012-.01-.01z'/><path fill='#FFFFFF' d='M18 4a1 1 0 1 0-2 0v1H4a1 1 0 0 0 0 2h12v1a1 1 0 1 0 2 0V7h2a1 1 0 1 0 0-2h-2zM4 11a1 1 0 1 0 0 2h2v1a1 1 0 1 0 2 0v-1h12a1 1 0 1 0 0-2H8v-1a1 1 0 0 0-2 0v1zm-1 7a1 1 0 0 1 1-1h12v-1a1 1 0 1 1 2 0v1h2a1 1 0 1 1 0 2h-2v1a1 1 0 1 1-2 0v-1H4a1 1 0 0 1-1-1'/></g></svg>
            `;
            parent.appendChild(adjustBtn);
          }
          
          if (shouldRestrictContent()) {
            adjustBtn.href = `${ACCESS_CONTROL.loginUrl}`;
          } else {
            adjustBtn.href = data.buttonConfig.adjustButtonPage;
          }
        
          // EXCLUSIVE BUTTON LOGIC: Hide ALL other buttons and show ONLY adjust button
          // Hide cart button with multiple methods
          cartBtn.style.setProperty('display', 'none', 'important');
          cartBtn.style.visibility = 'hidden';
          cartBtn.setAttribute('aria-hidden', 'true');
          cartBtn.setAttribute('data-force-hidden', 'true');
          
          // Hide variant button with multiple methods
          if (variantBtn) {
            variantBtn.style.setProperty('display', 'none', 'important');
            variantBtn.style.visibility = 'hidden';
            variantBtn.disabled = true;
            variantBtn.setAttribute('aria-hidden', 'true');
            variantBtn.setAttribute('data-force-hidden', 'true');
            // Clear previous product attributes
            variantBtn.removeAttribute('data-product-id');
            variantBtn.removeAttribute('data-product-url');
            variantBtn.removeAttribute('data-product-index');
          }
          
          // Show ONLY the adjust button
          adjustBtn.style.setProperty('display', 'flex', 'important');
          adjustBtn.style.visibility = 'visible';
          adjustBtn.removeAttribute('aria-hidden');
          adjustBtn.removeAttribute('data-force-hidden');
          
          if (!shouldRestrictContent()) {
            // Attach popup functionality to adjust button
            if (state.pagePopupInitialized && state.pagePopupTrigger) {
              attachPagePopupToLink(adjustBtn);
            } else {
              // Mark for attachment
              adjustBtn.setAttribute('data-pending-popup', 'true');
            }
          }
        } else {
          // No adjust button needed - hide any existing adjust button with multiple methods
          const adjustBtn = parent.querySelector('.adjust-btn-card');
          if (adjustBtn) {
            adjustBtn.style.setProperty('display', 'none', 'important');
            adjustBtn.style.visibility = 'hidden';
            adjustBtn.setAttribute('aria-hidden', 'true');
            adjustBtn.setAttribute('data-force-hidden', 'true');
          }
          
          // Get variant button reference from section (not parent element to avoid confusion)
          // Use section-specific selector to ensure we get the right button
          const section = document.getElementById(SECTION_ID);
          const variantBtn = elements.productInfoCard ? elements.productInfoCard.querySelector('[data-variant-btn]') : null;


          if (data.buttonConfig.hideAddToCart) {
            // EXCLUSIVE BUTTON LOGIC: Hide ALL buttons when add to cart is disabled
            cartBtn.style.setProperty('display', 'none', 'important');
            cartBtn.style.visibility = 'hidden';
            cartBtn.setAttribute('aria-hidden', 'true');
            cartBtn.setAttribute('data-force-hidden', 'true');
            
            if (variantBtn) {
              variantBtn.style.setProperty('display', 'none', 'important');
              variantBtn.style.visibility = 'hidden';
              variantBtn.disabled = true;
              variantBtn.setAttribute('aria-hidden', 'true');
              variantBtn.setAttribute('data-force-hidden', 'true');
              // Clear previous product attributes
              variantBtn.removeAttribute('data-product-id');
              variantBtn.removeAttribute('data-product-url');
              variantBtn.removeAttribute('data-product-index');
            }
          } else if (data.hasVariants) {
            // EXCLUSIVE BUTTON LOGIC: Product has variants - show ONLY variant button
            // Hide cart button completely
            cartBtn.style.setProperty('display', 'none', 'important');
            cartBtn.style.visibility = 'hidden';
            cartBtn.setAttribute('aria-hidden', 'true');
            cartBtn.setAttribute('data-force-hidden', 'true');
            
            if (variantBtn) {
              // Show and configure variant button with multiple visibility methods
              variantBtn.style.setProperty('display', 'flex', 'important');
              variantBtn.style.visibility = 'visible';
              variantBtn.disabled = false;
              variantBtn.removeAttribute('aria-hidden');
              variantBtn.removeAttribute('data-force-hidden'); // Remove force-hidden state
              variantBtn.setAttribute('data-product-id', data.productId);
              variantBtn.setAttribute('data-product-url', data.url);
              variantBtn.setAttribute('data-product-index', slideIndex);
            }
          } else {
            // EXCLUSIVE BUTTON LOGIC: Product has NO variants - show ONLY cart button
            if (variantBtn) {
              // Use multiple methods to force hide the variant button
              variantBtn.style.setProperty('display', 'none', 'important');
              variantBtn.style.visibility = 'hidden';
              variantBtn.disabled = true;
              variantBtn.setAttribute('aria-hidden', 'true');
              // Add a data attribute to track hidden state
              variantBtn.setAttribute('data-force-hidden', 'true');
              // Clear previous product attributes to prevent confusion
              variantBtn.removeAttribute('data-product-id');
              variantBtn.removeAttribute('data-product-url');
              variantBtn.removeAttribute('data-product-index');
            }

            // Show and configure cart button with enhanced visibility
            cartBtn.style.setProperty('display', 'flex', 'important');
            cartBtn.style.visibility = 'visible';
            cartBtn.disabled = !data.available;
            cartBtn.removeAttribute('aria-hidden');
            cartBtn.removeAttribute('data-force-hidden');
            cartBtn.setAttribute('data-product-id', data.productId);
            cartBtn.setAttribute('data-has-variants', data.hasVariants);
            cartBtn.setAttribute('data-product-url', data.url);
          }

        }
      }

    // Handle preorder button ONLY for products WITHOUT variants
    const section = document.getElementById(SECTION_ID);
    const preorderContainer = section ? section.querySelector('[data-preorder-btn-container]') : null;

    console.log('Main-scroll preorder check - initial:', {
      preorderContainer: preorderContainer,
      hasVariants: data.hasVariants,
      variantsLength: data.variants?.length
    });

    if (preorderContainer && !data.hasVariants) {
      // Check if first variant has preorder metafield
      let firstVariant = data.variants && data.variants.length > 0 ? data.variants[0] : null;

      // FALLBACK: If variants array is empty/undefined, get it from the main product data script
      if (!firstVariant) {
        try {
          const productDataScript = document.getElementById(`${SECTION_ID}-product-data`);
          if (productDataScript) {
            const allProductsData = JSON.parse(productDataScript.textContent);
            // Find the current product in the array
            const currentProduct = allProductsData.products?.[slideIndex];
            if (currentProduct && currentProduct.variants && currentProduct.variants.length > 0) {
              firstVariant = currentProduct.variants[0];
              console.log('Fallback: Found variant from product data script', firstVariant);
            }
          }
        } catch (e) {
          console.log('Could not parse product data for preorder check:', e);
        }
      }

      const isPreorder = firstVariant?.metafields?.custom?.is_pre_order_only;

      console.log('Main-scroll preorder check - detailed:', {
        hasVariants: data.hasVariants,
        firstVariant: firstVariant,
        metafields: firstVariant?.metafields,
        custom: firstVariant?.metafields?.custom,
        is_pre_order_only: isPreorder
      });

      if (isPreorder) {
        console.log('Showing preorder button in main-scroll');
        preorderContainer.innerHTML = `
          <page-popup-trigger
            class="preorder-button"
            data-page-handle="discounts-pricing"
            data-page-url="/pages/discounts-pricing"
          >
            <a
              href="/pages/discounts-pricing"
              aria-label="Preorder information"
              on:click="page-popup-trigger/handleClick"
            >
              <span class="preorder-button__icon">⚠️</span>
              <span class="preorder-button__text">PREORDER</span>
            </a>
          </page-popup-trigger>
        `;
        preorderContainer.style.display = 'block';
      } else {
        console.log('Hiding preorder button in main-scroll (isPreorder =', isPreorder, ')');
        preorderContainer.innerHTML = '';
        preorderContainer.style.display = 'none';
      }
    } else if (preorderContainer && data.hasVariants) {
      // Hide preorder button for products WITH variants (shown in variant dialog instead)
      console.log('Hiding preorder button for product with variants');
      preorderContainer.innerHTML = '';
      preorderContainer.style.display = 'none';
    } else {
      console.log('Preorder button check SKIPPED - no container found');
    }

    // Sync mobile preorder container
    if (mobilePreorderContainer && preorderContainer) {
      mobilePreorderContainer.innerHTML = preorderContainer.innerHTML;
      mobilePreorderContainer.style.display = preorderContainer.style.display;
    }

    // Sync mobile cart/variant/adjust buttons from desktop
    const mobileCartBtn = elements.section.querySelector('[data-cart-btn-mobile]');
    const mobileVariantBtn = elements.section.querySelector('[data-variant-btn-mobile]');
    const desktopCartBtn = elements.productInfoCard ? elements.productInfoCard.querySelector('[data-cart-btn]') : null;
    const desktopVariantBtn = elements.productInfoCard ? elements.productInfoCard.querySelector('[data-variant-btn]') : null;

    if (mobileCartBtn && desktopCartBtn) {
      mobileCartBtn.style.cssText = desktopCartBtn.style.cssText;
      mobileCartBtn.disabled = desktopCartBtn.disabled;
      mobileCartBtn.setAttribute('aria-hidden', desktopCartBtn.getAttribute('aria-hidden') || 'false');
      // Copy data attributes (NOT data-product-url — it would trigger the specs popup handler)
      ['data-product-id', 'data-has-variants'].forEach(attr => {
        if (desktopCartBtn.hasAttribute(attr)) {
          mobileCartBtn.setAttribute(attr, desktopCartBtn.getAttribute(attr));
        } else {
          mobileCartBtn.removeAttribute(attr);
        }
      });
    }

    if (mobileVariantBtn && desktopVariantBtn) {
      mobileVariantBtn.style.cssText = desktopVariantBtn.style.cssText;
      mobileVariantBtn.disabled = desktopVariantBtn.disabled;
      mobileVariantBtn.setAttribute('aria-hidden', desktopVariantBtn.getAttribute('aria-hidden') || 'false');
      // Copy data attributes (NOT data-product-url — it would trigger the specs popup handler)
      ['data-product-id', 'data-product-index'].forEach(attr => {
        if (desktopVariantBtn.hasAttribute(attr)) {
          mobileVariantBtn.setAttribute(attr, desktopVariantBtn.getAttribute(attr));
        } else {
          mobileVariantBtn.removeAttribute(attr);
        }
      });
    }

    // Sync adjust button to mobile
    const mobileProductInfoRight = elements.section.querySelector('.product-info-right.mobile-only');
    if (mobileProductInfoRight) {
      let mobileAdjustBtn = mobileProductInfoRight.querySelector('[data-adjust-btn-mobile]');
      const showAdjust = data.buttonConfig && data.buttonConfig.showAdjustButton && data.buttonConfig.adjustButtonPage;

      if (showAdjust) {
        const adjustHref = shouldRestrictContent() ? ACCESS_CONTROL.loginUrl : data.buttonConfig.adjustButtonPage;
        if (!mobileAdjustBtn) {
          // Create fresh button (don't clone to avoid inherited handlers/attributes)
          mobileAdjustBtn = document.createElement('a');
          mobileAdjustBtn.className = 'adjust-btn-card';
          mobileAdjustBtn.setAttribute('data-adjust-btn-mobile', '');
          mobileAdjustBtn.href = adjustHref;
          mobileAdjustBtn.innerHTML = `
            <svg xmlns='http://www.w3.org/2000/svg' width='32px' height='32px' viewBox='0 0 24 24'><title>settings_2_line</title><g id="settings_2_line" fill='none' fill-rule='evenodd'><path d='M24 0v24H0V0zM12.593 23.258l-.011.002-.071.035-.02.004-.014-.004-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01-.017.428.005.02.01.013.104.074.015.004.012-.004.104-.074.012-.016.004-.017-.017-.427c-.002-.01-.009-.017-.017-.018m.265-.113-.013.002-.185.093-.01.01-.003.011.018.43.005.012.008.007.201.093c.012.004.023 0 .029-.008l.004-.014-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014-.034.614c0 .012.007.02.017.024l.015-.002.201-.093.01-.008.004-.011.017-.43-.003-.012-.01-.01z'/><path fill='#FFFFFF' d='M18 4a1 1 0 1 0-2 0v1H4a1 1 0 0 0 0 2h12v1a1 1 0 1 0 2 0V7h2a1 1 0 1 0 0-2h-2zM4 11a1 1 0 1 0 0 2h2v1a1 1 0 1 0 2 0v-1h12a1 1 0 1 0 0-2H8v-1a1 1 0 0 0-2 0v1zm-1 7a1 1 0 0 1 1-1h12v-1a1 1 0 1 1 2 0v1h2a1 1 0 1 1 0 2h-2v1a1 1 0 1 1-2 0v-1H4a1 1 0 0 1-1-1'/></g></svg>
          `;
          mobileProductInfoRight.insertBefore(mobileAdjustBtn, mobileProductInfoRight.firstChild);
          // Direct click handler — no cloning, no shared state issues
          mobileAdjustBtn.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            if (state.pagePopupInitialized && state.pagePopupTrigger) {
              const url = new URL(this.href, window.location.origin);
              const relativeUrl = url.pathname + url.search;
              state.pagePopupTrigger.dataset.pageUrl = relativeUrl;
              state.pagePopupTrigger.handleClick(e);
            }
          });
        }
        mobileAdjustBtn.href = adjustHref;
        mobileAdjustBtn.style.setProperty('display', 'flex', 'important');
      } else if (mobileAdjustBtn) {
        mobileAdjustBtn.style.setProperty('display', 'none', 'important');
      }
    }

    // Update image slider
    updateImageSlider(slideIndex);
    state.currentProductIndex = slideIndex;

    if (section.dataset.currentProductHandle) {
      updateProductURL(slideIndex);
    }

    
  };
  
  // Programmatic scroll
  const scrollToSlide = (slideIndex) => {
    if (slideIndex < 0 || slideIndex >= elements.slides.length) return;
    
    // Use the slide's actual position for accuracy on all platforms
    const targetSlide = elements.slides[slideIndex];
    if (targetSlide) {
      elements.scrollContainer.scrollTo({
        top: targetSlide.offsetTop,
        behavior: 'smooth'
      });
    }
  };
  
  // Navigation handlers
  const handleKeyboardNavigation = (e) => {
    const currentSlide = state.currentProductIndex;
    const maxSlide = Math.min(elements.slides.length - 1, totalProducts - 1);
    
    switch(e.key) {
      case 'ArrowDown':
      case 'PageDown':
        e.preventDefault();
        scrollToSlide(Math.min(currentSlide + 1, maxSlide));
        break;
      
      case 'ArrowUp':
      case 'PageUp':
        e.preventDefault();
        scrollToSlide(Math.max(currentSlide - 1, 0));
        break;
      
      case 'ArrowLeft':
        if (state.imageSliderDots.length > 1) {
          e.preventDefault();
          switchToMedia(state.currentProductIndex, Math.max(state.currentImageIndex - 1, 0));
        }
        break;
      
      case 'ArrowRight':
        if (state.imageSliderDots.length > 1) {
          e.preventDefault();
          const maxImageIndex = state.imageSliderDots.length - 1;
          switchToMedia(state.currentProductIndex, Math.min(state.currentImageIndex + 1, maxImageIndex));
        }
        break;
      
      case 'Home':
        e.preventDefault();
        scrollToSlide(0);
        break;
      
      case 'End':
        e.preventDefault();
        scrollToSlide(maxSlide);
        break;
    }
  };
  
  // Wheel navigation for images
  const handleWheelNavigation = (e) => {
    if (state.imageSliderDots.length <= 1) return;
    
    // Only process horizontal wheel events
    if (Math.abs(e.deltaX) < Math.abs(e.deltaY) * 1.5) return;
    
    e.preventDefault();
    
    const now = Date.now();
    
    // Initialize gesture tracking
    if (!state.wheelGesture) {
      state.wheelGesture = {
        startTime: now,
        deltaX: 0,
        events: []
      };
    }
    
    // Reset if too much time has passed
    if (now - state.wheelGesture.startTime > 500) {
      state.wheelGesture = {
        startTime: now,
        deltaX: 0,
        events: []
      };
    }
    
    // Track this event
    state.wheelGesture.events.push({
      deltaX: e.deltaX,
      time: now
    });
    state.wheelGesture.deltaX += e.deltaX;
    
    // Check if we have a valid gesture (quick swipe with consistent direction)
    if (state.wheelGesture.events.length >= 3) {
      const duration = now - state.wheelGesture.startTime;
      const velocity = Math.abs(state.wheelGesture.deltaX) / duration;
      
      // Require high velocity and sufficient delta
      if (velocity > 0.5 && Math.abs(state.wheelGesture.deltaX) > 100 && !state.isWheelNavigating) {
        // Check if all events are in the same direction
        const direction = state.wheelGesture.deltaX > 0 ? 1 : -1;
        const consistentDirection = state.wheelGesture.events.every(evt => 
          Math.sign(evt.deltaX) === direction || evt.deltaX === 0
        );
        
        if (consistentDirection) {
          state.isWheelNavigating = true;
          const maxImageIndex = state.imageSliderDots.length - 1;
          
          if (direction > 0) {
            switchToMedia(state.currentProductIndex, Math.min(state.currentImageIndex + 1, maxImageIndex));
          } else {
            switchToMedia(state.currentProductIndex, Math.max(state.currentImageIndex - 1, 0));
          }
          
          // Reset gesture
          state.wheelGesture = null;
          
          // Cooldown
          setTimeout(() => {
            state.isWheelNavigating = false;
          }, 1000);
        }
      }
    }
    
    // Clean up old gesture after timeout
    clearTimeout(state.wheelTimeout);
    state.wheelTimeout = setTimeout(() => {
      state.wheelGesture = null;
      state.isWheelNavigating = false;
    }, 300);
  };
  
  // Touch handling — TikTok/Reels style on mobile
  // No native scroll; every swipe is a deliberate gesture.
  const handleTouchStart = (e) => {
    state.touchStartX = e.touches[0].clientX;
    state.touchStartY = e.touches[0].clientY;
    state.touchStartTime = Date.now();
    state.isHorizontalSwipe = false;
    state.isVerticalSwipe = false;
    state.initialScrollTop = elements.scrollContainer.scrollTop;
  };

  const handleTouchMove = (e) => {
    const deltaX = e.touches[0].clientX - state.touchStartX;
    const deltaY = e.touches[0].clientY - state.touchStartY;

    if (!state.isHorizontalSwipe && !state.isVerticalSwipe) {
      if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 10) {
        state.isHorizontalSwipe = true;
        if (state.imageSliderDots.length > 1) {
          e.preventDefault();
        }
      } else if (Math.abs(deltaY) > Math.abs(deltaX) && Math.abs(deltaY) > 10) {
        state.isVerticalSwipe = true;
        // Mobile: block ALL native vertical scroll — gestures are handled in touchend
        if (window.innerWidth < 750) {
          e.preventDefault();
        }
      }
    } else if (state.isVerticalSwipe && window.innerWidth < 750) {
      e.preventDefault(); // keep blocking while dragging
    }
  };

  const handleTouchEnd = (e) => {
    const isMobile = window.innerWidth < 750;

    // Handle horizontal swipe for images
    if (state.imageSliderDots.length > 1 && state.isHorizontalSwipe) {
      const touchEndX = e.changedTouches[0].clientX;
      const deltaX = touchEndX - state.touchStartX;
      const touchDuration = Date.now() - state.touchStartTime;

      if (Math.abs(deltaX) > SWIPE_THRESHOLD && touchDuration < SWIPE_TIME_THRESHOLD) {
        const maxImageIndex = state.imageSliderDots.length - 1;

        if (deltaX < 0) {
          switchToMedia(state.currentProductIndex, Math.min(state.currentImageIndex + 1, maxImageIndex));
        } else {
          switchToMedia(state.currentProductIndex, Math.max(state.currentImageIndex - 1, 0));
        }
      }
    }

    // Mobile: TikTok-style vertical swipe
    if (isMobile && state.isVerticalSwipe) {
      const deltaY = e.changedTouches[0].clientY - state.touchStartY;
      const touchDuration = Date.now() - state.touchStartTime;
      const velocity = Math.abs(deltaY) / touchDuration;

      const MOBILE_SWIPE_THRESHOLD = 50;
      const MOBILE_VELOCITY_THRESHOLD = 0.2;

      if ((Math.abs(deltaY) > MOBILE_SWIPE_THRESHOLD || velocity > MOBILE_VELOCITY_THRESHOLD) && touchDuration < SWIPE_TIME_THRESHOLD) {
        const currentIdx = getCurrentSlideIndex();
        const maxSlide = elements.slides.length - 1;
        const slide = elements.slides[currentIdx];
        const slideState = getSlideScrollState();

        if (deltaY < 0) {
          // SWIPE UP
          if (slideState.overflows && !slideState.atBottom) {
            // Tall slide: scroll down to reveal more content (one page at a time)
            const scrollTop = elements.scrollContainer.scrollTop;
            const containerH = elements.scrollContainer.clientHeight;
            const slideBottom = slide.offsetTop + slide.offsetHeight;
            const target = Math.min(scrollTop + containerH, slideBottom - containerH);
            elements.scrollContainer.scrollTo({ top: target, behavior: 'smooth' });
          } else if (currentIdx < maxSlide) {
            // At bottom of slide (or short slide): next product
            scrollToSlide(currentIdx + 1);
          }
        } else {
          // SWIPE DOWN
          if (slideState.overflows && !slideState.atTop) {
            // Tall slide: scroll back up (one page at a time)
            const scrollTop = elements.scrollContainer.scrollTop;
            const containerH = elements.scrollContainer.clientHeight;
            const target = Math.max(slide.offsetTop, scrollTop - containerH);
            elements.scrollContainer.scrollTo({ top: target, behavior: 'smooth' });
          } else if (currentIdx > 0) {
            // At top of slide: previous product
            scrollToSlide(currentIdx - 1);
          }
        }
      }
    }

    state.isHorizontalSwipe = false;
    state.isVerticalSwipe = false;
  };

  // Cart functionality
  const cartHelpers = {
    getSectionsToUpdate() {
      const sections = [];
      
      
      // Add cart icon section
      const cartIconSection = document.querySelector('.header-actions__cart-icon')?.closest('[id^="shopify-section-"]');
      if (cartIconSection) {
        const sectionId = cartIconSection.id.replace('shopify-section-', '');
        if (sectionId) sections.push(sectionId);
      }
      
      return sections;
    },

    showOverlay(message, duration = 3000) {
      let overlay = document.getElementById('productScrollMessageOverlay');
      if (!overlay) {
        overlay = document.createElement('div');
        overlay.id = 'productScrollMessageOverlay';
        overlay.style.cssText = `
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background: rgba(0, 0, 0, 0.9);
          color: white;
          padding: 20px 30px;
          border-radius: 8px;
          z-index: 10000;
          pointer-events: none;
          opacity: 0;
          transition: opacity 0.3s ease;
          max-width: 90%;
          text-align: center;
        `;
        overlay.classList.add('product-scroll-overlay');
        document.body.appendChild(overlay);
      }
      
      overlay.textContent = message;
      overlay.style.opacity = '1';
      
      setTimeout(() => {
        overlay.style.opacity = '0';
      }, duration);
    },

    triggerFlyToCartAnimation(button, productImage) {
      const cartIcon = document.querySelector('.header-actions__cart-icon');
      
      if (!cartIcon || !button) return;
      
      // Create fly-to-cart element if the theme supports it
      if (window.customElements && window.customElements.get('fly-to-cart')) {
        const flyToCartElement = document.createElement('fly-to-cart');
        
        if (productImage) {
          const imageUrl = productImage.src || productImage.dataset.src;
          if (imageUrl) {
            flyToCartElement.style.setProperty('background-image', `url(${imageUrl})`);
          }
        }
        
        flyToCartElement.source = button;
        flyToCartElement.destination = cartIcon;
        document.body.appendChild(flyToCartElement);
      } else {
        // Fallback animation
        const rect = button.getBoundingClientRect();
        const cartRect = cartIcon.getBoundingClientRect();
        
        const flyingItem = document.createElement('div');
        flyingItem.style.cssText = `
          position: fixed;
          left: ${rect.left}px;
          top: ${rect.top}px;
          width: 30px;
          height: 30px;
          background: var(--accent-color, #000);
          border-radius: 50%;
          z-index: 10000;
          pointer-events: none;
          transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        `;
        
        document.body.appendChild(flyingItem);
        
        // Force reflow
        flyingItem.offsetHeight;
        
        // Animate to cart
        flyingItem.style.left = `${cartRect.left + cartRect.width / 2 - 15}px`;
        flyingItem.style.top = `${cartRect.top + cartRect.height / 2 - 15}px`;
        flyingItem.style.transform = 'scale(0)';
        flyingItem.style.opacity = '0';
        
        setTimeout(() => flyingItem.remove(), 800);
      }
    },

    dispatchCartEvents(response, sections, productId) {
      const cartUpdateEvent = new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: response,
          sourceId: SECTION_ID,
          data: {
            source: 'product-scroll-component',
            itemCount: 1,
            productId: productId,
            variantId: response.variant_id || response.id,
            sections: sections,
            didError: false
          }
        }
      });
      
      document.dispatchEvent(cartUpdateEvent);
      
      // Also dispatch a simpler event for compatibility
      document.dispatchEvent(new CustomEvent('cart:updated', {
        bubbles: true,
        detail: response
      }));
    },

    updateCartIconCount(itemCount) {
      const cartCountElements = document.querySelectorAll('.cart-bubble__text-count, .cart-count-bubble, [data-cart-count]');
      
      cartCountElements.forEach(element => {
        if (element) {
          element.textContent = itemCount;
          
          const bubble = element.closest('.cart-bubble');
          if (bubble) {
            bubble.classList.toggle('visually-hidden', itemCount === 0);
          }
        }
      });
      
      const cartIcons = document.querySelectorAll('.header-actions__cart-icon');
      cartIcons.forEach(icon => {
        icon.classList.toggle('header-actions__cart-icon--has-cart', itemCount > 0);
      });
      
      // Store in session
      sessionStorage.setItem('cart-count', JSON.stringify({
        value: String(itemCount),
        timestamp: Date.now()
      }));
    },

    

    async updateCartCount() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        
        // Update cart count
        this.updateCartIconCount(cart.item_count);
      
      } catch (error) {
        console.error('Error fetching updated cart:', error);
      }
    }
  };
  
  // Cart button handler
  const handleCartButtonClick = async function(e) {

  if (shouldRestrictContent()) {
    e.preventDefault();
    window.location.href = '/account/login';
    return;
  }


    e.preventDefault();
    
    const variantId = this.getAttribute('data-product-id');
    const hasVariants = this.getAttribute('data-has-variants') === 'true';
    const productUrl = this.getAttribute('data-product-url');
    const productId = elements.slides[state.currentProductIndex]?.getAttribute('data-product-id');
    
    if (hasVariants) {
      // Preserve existing query parameters when navigating to product with variants
      const currentUrl = new URL(window.location.href);
      const targetUrl = new URL(productUrl, window.location.origin);

      // Copy query parameters from current URL to target URL
      currentUrl.searchParams.forEach((value, key) => {
        targetUrl.searchParams.set(key, value);
      });

      window.location.href = targetUrl.toString();
      return;
    }
    
    if (!variantId) {
      console.error('No variant ID found');
      cartHelpers.showOverlay('No variant selected');
      return;
    }
    
    const buttonIcon = this.querySelector('svg');
    const originalIcon = buttonIcon.outerHTML;
    
    // Disable button and show loading state
    this.disabled = true;
    buttonIcon.outerHTML = '<div class="loading-spinner" style="width: 16px; height: 16px;"></div>';
    
    // Prepare form data
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    
    // Add sections to fetch for updates
    const sectionsToUpdate = cartHelpers.getSectionsToUpdate();
    if (sectionsToUpdate.length > 0) {
      formData.append('sections', sectionsToUpdate.join(','));
    }
    
    // Get product image for animation
    const currentSlide = elements.slides[state.currentProductIndex];
    const productImage = currentSlide?.querySelector('.product-bg-image.active, .product-bg-video.active');
    
    // Trigger fly-to-cart animation
    cartHelpers.triggerFlyToCartAnimation(this, productImage);
    
    try {
      const response = await fetch(window.Theme?.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json, text/javascript'
        }
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        console.error('Shopify cart error:', errorData);
        cartHelpers.showOverlay(errorData.message || errorData.description || 'Failed to add to cart');
        throw new Error(errorData.message || 'Failed to add to cart');
      }
      
      const data = await response.json();
      
      // Success
      this.querySelector('.loading-spinner').outerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>';
      
      // Update sections if provided
      const sections = data.sections || {};
      Object.keys(sections).forEach(sectionId => {
        const sectionElement = document.getElementById(`shopify-section-${sectionId}`);
        if (sectionElement && sections[sectionId]) {
          if (window.morphSection && typeof window.morphSection === 'function') {
            window.morphSection(sectionId, sections[sectionId]);
          } else {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = sections[sectionId];
            sectionElement.innerHTML = tempDiv.innerHTML;
          }
        }
      });
      
      // Dispatch cart events
      cartHelpers.dispatchCartEvents(data, sections, productId);
      
      // Update cart count
      await cartHelpers.updateCartCount();
      
      // Reset button after delay
      setTimeout(() => {
        this.disabled = false;
        this.querySelector('svg').outerHTML = originalIcon;
      }, 2000);
      
    } catch (error) {
      console.error('Cart error:', error);
      
      // Reset button on error
      this.disabled = false;
      const spinner = this.querySelector('.loading-spinner');
      if (spinner) {
        spinner.outerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>';
      }
      
      // Reset icon after showing error
      setTimeout(() => {
        this.querySelector('svg').outerHTML = originalIcon;
      }, 2000);
      
      // Dispatch error event
      const errorEvent = new CustomEvent('cart:error', {
        bubbles: true,
        detail: {
          sourceId: SECTION_ID,
          data: {
            message: error.message || 'Failed to add item to cart',
            originalError: error
          }
        }
      });
      
      document.dispatchEvent(errorEvent);
    }
  };


  const initializeNavigationTutorial = () => {
        const navOverlay = elements.section.querySelector('.nav-tutorial-overlay');
        if (!navOverlay) return;
        
        const DEBUG_MODE = false; // Set to true for testing
        const hasSeenTutorial = sessionStorage.getItem('hasSeenNavigationTutorial');
        const permanentlyDismissed = localStorage.getItem('navigationTutorialDismissed');
        
        if (!hasSeenTutorial && !permanentlyDismissed || DEBUG_MODE) {
          let currentStep = 1;
          const steps = navOverlay.querySelectorAll('.nav-tutorial-step');
          const dontShowCheckbox = navOverlay.querySelector('#dontShowAgain');
          
          // Show overlay
          navOverlay.classList.add('visible');
          lockBodyScroll();
          
          // Handle step progression
          const showStep = (stepNumber) => {
            steps.forEach(step => {
              step.style.display = step.dataset.step == stepNumber ? 'flex' : 'none';
            });
          };
          
          // Handle button clicks
          navOverlay.addEventListener('click', (e) => {
            if (e.target.matches('[data-action="next"]')) {
              currentStep++;
              showStep(currentStep);
            } else if (e.target.matches('[data-action="finish"]')) {
              // Check if user wants to permanently dismiss
              if (dontShowCheckbox && dontShowCheckbox.checked) {
                localStorage.setItem('navigationTutorialDismissed', 'true');
              }
              sessionStorage.setItem('hasSeenNavigationTutorial', 'true');
              
              // Hide overlay
              navOverlay.classList.remove('visible');
              unlockBodyScroll();
            }
          });
          
          // Prevent closing on overlay click
          navOverlay.addEventListener('click', (e) => {
            if (e.target === navOverlay) {
              e.stopPropagation();
            }
          });
          
          // Handle escape key
          const escapeHandler = (e) => {
            if (e.key === 'Escape') {
              sessionStorage.setItem('hasSeenNavigationTutorial', 'true');
              navOverlay.classList.remove('visible');
              unlockBodyScroll();
              document.removeEventListener('keydown', escapeHandler);
            }
          };
          document.addEventListener('keydown', escapeHandler);
        }
      };

  const updateProductURL = debounce((productIndex) => {
        // Nur auf Produktseiten die URL updaten
        if (!section.dataset.currentProductHandle) return;

        const product = state.loadedProducts.get(productIndex);
        if (!product || !product.url) return;

        // Verwende replaceState um die URL zu ändern ohne History-Eintrag
        if (window.history && window.history.replaceState) {
          // Preserve existing query parameters from current URL
          const currentUrl = new URL(window.location.href);
          const newUrl = new URL(product.url, window.location.origin);

          // Copy query parameters from current URL to new URL
          currentUrl.searchParams.forEach((value, key) => {
            newUrl.searchParams.set(key, value);
          });

          window.history.replaceState(
            { productIndex: productIndex },
            product.title,
            newUrl.toString()
          );
          
          // Update Meta-Tags (optional)
          document.title = `${product.title} – ${window.Theme?.shop?.name || ''}`;
          
          // Update Open Graph tags
          const ogTitle = document.querySelector('meta[property="og:title"]');
          if (ogTitle) ogTitle.content = product.title;
          
          const ogUrl = document.querySelector('meta[property="og:url"]');
          if (ogUrl) ogUrl.content = newUrl.toString();
        }
      }, 500);
  
  // Resize handler reference for cleanup
  let resizeHandler = null;
  
  // Initialize section

const init = () => {
  // Cache elements
  elements.scrollContainer = elements.section.querySelector('[data-scroll-container]');
  elements.slides = elements.section.querySelectorAll('.product-slide');
  elements.navOverlay = elements.section.querySelector('[data-nav-overlay]');
  elements.productInfoCard = elements.section.querySelector('[data-product-info]');
  elements.imageSlider = elements.section.querySelector('[data-image-slider]');
  elements.captionArea = elements.section.querySelector('.caption-area');
  elements.captionContent = elements.section.querySelector('[data-caption-content]');
  elements.expandOverlay = elements.section.querySelector('[data-expand-overlay]');

  
  if (!elements.scrollContainer || !elements.slides.length) return;
  
  // Lock body scroll
  lockBodyScroll();
  initializePagePopup();
  setupExpandOverlay();
  
  // Caption area is now natively scrollable - no swipe setup needed
  
  // Initial-Index basierend auf Produkt-Handle
  const currentProductIndex = parseInt(section.dataset.currentProductIndex) || 0;
  const currentProductHandle = section.dataset.currentProductHandle || '';

  // Berechne optimalen Ladebereich
  const loadRangeStart = Math.max(0, currentProductIndex - bufferCount);
  const loadRangeEnd = Math.min(totalProducts, currentProductIndex + bufferCount + 1);

  // IMPORTANT FIX: Ensure we have enough slide elements for the current product
  // Only create slides up to currentProductIndex + buffer for performance
  // This fixes the issue where products at index > 4 couldn't be scrolled to
  const currentSlideCount = elements.slides.length;

  // Only create slides if we need to scroll to a product beyond what exists
  if (currentProductHandle && currentProductIndex >= currentSlideCount) {
    // Create only enough slides to reach the current product plus a small buffer
    // But never exceed the total number of products
    const requiredSlides = Math.min(currentProductIndex + bufferCount + 1, totalProducts);

    const fragment = document.createDocumentFragment();

    for (let i = currentSlideCount; i < requiredSlides; i++) {
      const placeholder = document.createElement('article');
      placeholder.className = 'product-slide placeholder';
      placeholder.setAttribute('data-slide-index', i);
      placeholder.setAttribute('role', 'listitem');
      placeholder.setAttribute('aria-label', 'Loading product');
      fragment.appendChild(placeholder);
    }

    elements.scrollContainer.appendChild(fragment);
    // Update slides reference to include new slides
    elements.slides = elements.scrollContainer.querySelectorAll('.product-slide');
  }

  // Intelligentes Initial Loading - lädt Produkte um das aktuelle Produkt herum
  const productsToLoad = new Set();

  // When deep linking, load ALL products from 0 to current + buffer to avoid gaps
  if (currentProductHandle && currentProductIndex > 0) {
    // Load everything from start to current product + buffer
    const endLoad = Math.min(currentProductIndex + bufferCount + 1, totalProducts);
    for (let i = 0; i < endLoad; i++) {
      productsToLoad.add(i);
    }
  } else {
    // Normal initial load - just load first batch
    for (let i = 0; i < Math.min(initialLoadCount, totalProducts); i++) {
      productsToLoad.add(i);
    }
  }
  
  // Lade alle Produkte in der Liste
  productsToLoad.forEach(i => {
    const slideElement = elements.slides[i];
    if (slideElement) {
      loadProductIntoSlide(i, slideElement);
    }
  });

       setTimeout(() => {
          fitOverlayTextToWidth();
        }, 100);
  
      initializeNavigationTutorial();
        
  // Event listeners
  elements.scrollContainer.addEventListener('scroll', updateScrollIndicator, { passive: true });
  elements.scrollContainer.addEventListener('wheel', handleWheelNavigation, { passive: false });
  
  // Touch events - scroll container
  elements.scrollContainer.addEventListener('touchstart', handleTouchStart, { passive: true });
  elements.scrollContainer.addEventListener('touchmove', handleTouchMove, { passive: false });
  elements.scrollContainer.addEventListener('touchend', handleTouchEnd, { passive: true });

  // (Info card hidden on mobile; caption is embedded in slides)
  
  // Keyboard navigation
  document.addEventListener('keydown', handleKeyboardNavigation);
  
  // Cart button (desktop)
  const cartBtn = elements.productInfoCard?.querySelector('[data-cart-btn]');
  if (cartBtn) {
    cartBtn.addEventListener('click', handleCartButtonClick);
  }

  // Mobile cart button
  const mobileCartBtn = elements.section.querySelector('[data-cart-btn-mobile]');
  if (mobileCartBtn) {
    mobileCartBtn.addEventListener('click', handleCartButtonClick);
  }

  // Mobile variant button
  const mobileVariantBtn = elements.section.querySelector('[data-variant-btn-mobile]');
  if (mobileVariantBtn) {
    mobileVariantBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const productIndex = parseInt(this.getAttribute('data-product-index')) || state.currentProductIndex;
      openVariantSelection(productIndex);
    });
  }
  
  // Make entire product-info-right clickable to match the action of the visible button
  const productInfoRight = elements.productInfoCard?.querySelector('.product-info-right');
  if (productInfoRight) {
    productInfoRight.style.cursor = 'pointer';
    productInfoRight.addEventListener('click', function(e) {
      // Don't trigger if clicking directly on any button (avoid double trigger)
      if (e.target.closest('[data-cart-btn]') ||
          e.target.closest('[data-variant-btn]') ||
          e.target.closest('.adjust-btn-card') ||
          e.target.closest('.preorder-button')) {
        return;
      }
      
      // Find which button is visible and trigger its action
      const cartBtn = this.querySelector('[data-cart-btn]');
      const variantBtn = this.querySelector('[data-variant-btn]');
      const adjustBtn = this.querySelector('.adjust-btn-card');
      
      // Check cart button visibility and trigger if visible
      if (cartBtn && 
          !cartBtn.disabled && 
          getComputedStyle(cartBtn).display !== 'none') {
        handleCartButtonClick.call(cartBtn, e);
        return;
      }
      
      // Check variant button visibility and trigger if visible
      if (variantBtn && 
          !variantBtn.disabled && 
          getComputedStyle(variantBtn).display !== 'none') {
        const productIndex = parseInt(variantBtn.getAttribute('data-product-index')) || state.currentProductIndex;
        openVariantSelection(productIndex);
        return;
      }
      
      // Check adjust button visibility and trigger if visible
      if (adjustBtn && 
          getComputedStyle(adjustBtn).display !== 'none') {
        // Trigger the adjust button's click handler
        adjustBtn.click();
        return;
      }
    });
  }
  
  // Caption area scroll chaining is now handled by unified touch handlers on productInfoCard
  
  // Viewport resize handling
  let resizeTimeout;
  let previousWidth = window.innerWidth;
  resizeHandler = () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      const currentWidth = window.innerWidth;
      const wasDesktop = previousWidth >= 1024;
      const isDesktop = currentWidth >= 1024;

      updateScrollIndicator();
      scrollToSlide(state.currentProductIndex);

      if (wasDesktop !== isDesktop) {
        const preservedImageIndex = state.currentImageIndex;
        switchToMedia(state.currentProductIndex, preservedImageIndex);
      }

      // Update video quality for responsive loading
      updateVideoQuality();

      debouncedFitOverlayText();

      previousWidth = currentWidth;
    }, 250);
  };
  window.addEventListener('resize', resizeHandler);
  

      // Scroll zum aktuellen Produkt - INSTANT ohne sichtbares Scrollen
      // Fixed: Changed condition to allow scrolling even to index 0
      if (currentProductHandle && currentProductIndex >= 0) {

        // Temporarily disable scroll event handler to prevent interference
        const tempScrollHandler = updateScrollIndicator;
        elements.scrollContainer.removeEventListener('scroll', tempScrollHandler);

        // Verstecke Container während der Positionierung
        elements.scrollContainer.style.visibility = 'hidden';
        elements.scrollContainer.style.pointerEvents = 'none';

        // Setze Position SOFORT ohne Animation - use actual slide position
        // Safari-Fix: Snap + smooth-Scroll während des Sprungs deaktivieren
        const prevSnapType = elements.scrollContainer.style.scrollSnapType;
        const prevScrollBehavior = elements.scrollContainer.style.scrollBehavior;
        elements.scrollContainer.style.scrollSnapType = 'none';
        elements.scrollContainer.style.scrollBehavior = 'auto';
        const targetSlide = elements.slides[currentProductIndex];
        if (targetSlide) {
          elements.scrollContainer.scrollTop = targetSlide.offsetTop;
        }

        // Update state sofort
        state.currentProductIndex = currentProductIndex;

        // Sofort die Info-Card updaten
        updateProductInfoCard(currentProductIndex);

        // Re-enable scroll handler after a brief delay
        setTimeout(() => {
          elements.scrollContainer.addEventListener('scroll', tempScrollHandler, { passive: true });
        }, 500);
        
        // Lade Media für das aktuelle Produkt mit Priorität
        const currentSlide = elements.slides[currentProductIndex];
        if (currentSlide) {
          const currentProduct = state.loadedProducts.get(currentProductIndex);
          if (currentProduct) {
            loadAllMediaForSlide(currentSlide, currentProduct);
          }
        }
        
        // Zeige Container wieder nach minimalem Delay (für Browser-Rendering)
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            elements.scrollContainer.style.visibility = 'visible';
            elements.scrollContainer.style.pointerEvents = 'auto';
            // Safari-Fix: Position nach dem Sichtbarwerden erneut setzen, dann Snap wieder an
            const ts = elements.slides[currentProductIndex];
            if (ts) elements.scrollContainer.scrollTop = ts.offsetTop;
            requestAnimationFrame(() => {
              const ts2 = elements.slides[currentProductIndex];
              if (ts2) elements.scrollContainer.scrollTop = ts2.offsetTop;
              elements.scrollContainer.style.scrollSnapType = prevSnapType || '';
              elements.scrollContainer.style.scrollBehavior = prevScrollBehavior || '';
            });
            
            // Fade-in Effekt (optional)
            elements.scrollContainer.style.opacity = '0';
            elements.scrollContainer.style.transition = 'opacity 0.2s ease';
            
            setTimeout(() => {
              elements.scrollContainer.style.opacity = '1';
            }, 10);
            
            // Preload adjacent slides
            preloadAdjacentSlides(currentProductIndex);
          });
        });
      } else {
        // Standard-Initialisierung für Homepage
        updateProductInfoCard(0);
        
        if (elements.slides[0]) {
          const firstProduct = state.loadedProducts.get(0);
          if (firstProduct) {
            loadAllMediaForSlide(elements.slides[0], firstProduct);
          }
        }
      }
  

  // Cleanup on section removal
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.removedNodes.length) {
        mutation.removedNodes.forEach((node) => {
          if (node === elements.section || node.contains(elements.section)) {
            cleanup();
          }
        });
      }
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
};
  

  // Cleanup function
  const cleanup = () => {
    unlockBodyScroll();
    document.removeEventListener('keydown', handleKeyboardNavigation);
    if (resizeHandler) {
      window.removeEventListener('resize', resizeHandler);
    }
    
    // Clean up media
    state.imagesLoaded.clear();
    state.videosLoaded.clear();
    state.loadedProducts.clear();
    state.loadedSlides.clear();
    state.preloadQueue = [];
  };

  // ===== VARIANT SELECTION DIALOG FUNCTIONALITY =====
  
  // Get variant selection dialog instance
  let variantDialog = null;

  // Initialize variant dialog
  const initializeVariantDialog = () => {
    variantDialog = document.getElementById('variant-selection-dialog');
    if (!variantDialog) {
      console.error('Variant selection dialog not found');
      return false;
    }
    return true;
  };

  // Open variant selection dialog
  const openVariantSelection = (productIndex) => {
    if (!variantDialog && !initializeVariantDialog()) {
      console.error('Cannot open variant selection: dialog not available');
      return;
    }
    
    const product = allProducts[productIndex];
    if (!product || !product.hasVariants || !product.options?.length) {
      console.warn('Product does not have variants or options');
      return;
    }

    // Open the variant selection dialog
    variantDialog.openVariantSelection(product);
  };

  // Setup variant button click handlers using event delegation
  const initializeVariantButtons = () => {
    // Use event delegation for better performance
    document.addEventListener('click', (e) => {
      const variantBtn = e.target.closest(`#${SECTION_ID} [data-variant-btn]`);
      if (variantBtn) {
        e.preventDefault();
        e.stopPropagation();
        
        const productIndex = parseInt(variantBtn.getAttribute('data-product-index')) || state.currentProductIndex;
        openVariantSelection(productIndex);
      }
    });
  };

  // Call this during initialization
  const originalInit = init;
  const enhancedInit = function() {
    originalInit();
    
    // Initialize variant dialog and buttons after main initialization
    setTimeout(() => {
      initializeVariantDialog();
      initializeVariantButtons();
    }, 100);
  };
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhancedInit);
  } else {
    enhancedInit();
  }
})();

